export default {
    "ch": {
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            }
        }
    },
    "en": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "exception": "Sorry we are unable to process your request, please try again!",
            "reset-password": {
                "sms": "To reset the password for your iBS account, please enter the OTP {otp}, expires {validity} min. {url}",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS login password.  \n            <br>\n            Please enter the one-time password (OTP) : {otp} \n            <br>\n            The OTP only valid for {validity} minutes.  \n            <br><br>\n            {url}\n            If you do not want to reset your password, you may simply ignore or delete this email; your login password will not be changed, and you will still be able to access your member portal.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-security-pin-sent": "We have e-mailed you security pin reset instructions!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS EWallet security pin.  \n            <br>\n            Please login to your member portal follow the steps below:\n            <br>\n            1. Go to <b>My Account</b>.\n            <br>\n            2. Click on <b>e-Wallet Settings</b> tab.\n            <br>\n            3. Click on <b>Reset</b> button and follow through the step by step process.\n            <br><br>\n            If you do not want to reset your security pin, you may simply ignore or delete this email; your security pin will not be changed, and you will still be able to access your e-wallet.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-attempt-max": "You’ve reached the maximum attempt. Please try again later.",
            "reset-attempt-gap": "You are resetting the password too often. Please try again later.",
            "reset-attempt-expire": "OTP Was Invalid Because Maximum Attempted For Reset Password Was Reached. Please Request Reset Password Again"
        },
        "resume_payment": {
            "email": {
                "subject": "Your order {document_number} is waiting for you"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "master": "{attribute} is not valid master data for `{master_key}`, the valid ids are: {master_ids}.",
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item",
                "invalid_voucher_status": "Only voucher with the status of [Posted] can be redeemed"
            }
        },
        "email": {
            "welcome": {
                "subject": "Welcome to Elken IBS",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for registering on our IBS system and we welcome you onboard",
                "visit": "Visit IBS",
                "footer": "Thank you for using our Elken IBS!"
            },
            "staff_welcome": {
                "subject": "Welcome to Elken",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for being part of Elken. and welcome on board.",
                "credentials": "please use the following credentials to login in to our IBS.",
                "email": "Email: {email}",
                "password": "Password: {password}",
                "visit": "Visit IBS",
                "footer": "Elken IBS!"
            }
        },
        "enrollment": {
            "email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Welcome to Elken</span>\n            <br><br>\n            \n            Congratulations on taking your first step with us to secure your future and personal financial success. It is the right time and you have made a fantastic choice to be part of us. \n            <br><br>\n            The Elken Global Compensation Plan is designed to be rewarding and sustainable to ensure you have a strong and profitable business. \n            <br><br>\n             We encourage you to take the time to familiarize yourself with the Elken Global Compensation Plan, business tool/management and products to help you build a successful business. As a member, you are entitled to purchase our products at member price.\n            <br><br>\n            Once again, thank you for making the right decision to <span style=\"color: red\">join us</span> . \n            <br><br>\n            To Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>            \n            Your Login Info<br>\n            Member ID: {iboMemberId}<br><br>Current Password: {password}<br><br>*You can change your password by logging into member portal.\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "Welcome to Elken Global and congratulations on your enrollment! Please log into your iBS: {url} with IBO ID: {iboMemberId} Password: {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "email_temp": {
                "subject": "Elken Enrollment Unique ID",
                "content": "\n        Dear : {name} \n        <br>\n        Welcome to Elken Global and thank your for start the Enrollment process!\n        <br><br>\n        Elken Enrollment Unique id : {unique_id}.\n        <br><br>  \n        please keep this unique ID to resume enrollment later if you did not complete the process."
            },
            "taiwan_enrollment_form": "\n        Dear {name} <br>\n        Welcome to Elken Taiwan, congratulation on completing your registration and taking the first step in your Elken  journey! Through Elken's high quality products and system training, Elken will aid you towards a better life. Thank you for being together with Elken, creating a better future with us! Lastly, as a reminder, please make sure all the documents listed on the link below has been provided. If the documents have been submitted, kindly ignore this message. <br>\n        <br><br>\n        <a href=\"https://bit.ly/twnmg\">New Member Document Checklist</a>\n        <br><br>\n        <a href=\"{link}\">Please click here</a> to bring out your Elken membership and terms and condition form<br>\n        For assistance, please call us on your toll-free customer care helpline：0800-880-689<br>\n        Thank you<br><br>\n        website: www.elkenglobal.com<br>\n        email: customerservice@elken.com<br>\n        &lt; - - - This is an automatic system generated message, please do not reply- - - &gt;\n    ",
            "taiwan_enrollment_sms": {
                "content": "Dear {name}, Welcome to Elken Taiwan, congratulation on completing your registration and taking the first step in your Elken  journey! Through Elken's high quality products and system training, Elken will aid you towards a better life. Thank you for being together with Elken, creating a better future with us! Lastly, as a reminder, please make sure all the documents listed on the link below has been provided. If the documents have been submitted, kindly ignore this message. New Member Document Checklist https://bit.ly/twnmg {link} to bring out your Elken membership and terms and condition form. For assistance, please call us on your toll-free customer care helpline：0800-880-689. Thank you. website: www.elkenglobal.com"
            },
            "duplicated_enrollment_error": "Failure to complete enrolment due to the provided contact details already exist in our database. Please contact CS."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "countries_dynamic_content": {
            "address": {
                "Permanent": "Permanent",
                "Correspondence": "Correspondence",
                "Shipping 1": "Shipping 1",
                "Shipping 2": "Shipping 1",
                "Address 1": "Address 1",
                "Address 2": "Address 2",
                "Address 3": "Address 3",
                "Address 4": "Address 4",
                "postcode": "Postcode",
                "Postcode": "Postcode",
                "state": "State",
                "State": "State",
                "city": "City",
                "City": "City",
                "country": "Country",
                "Country": "Country"
            },
            "member_payout_options": {
                "BANK": "BANK",
                "Bank Country": "Bank Country",
                "Bank Name": "Bank Name",
                "A/C Holder Name": "A/C Holder Name",
                "Swift Code": "Swift Code",
                "Account Type": "Account Type",
                "Bank Account No": "Bank Account No",
                "Bank Account IC": "Bank Account IC",
                "Payout Company": "Payout Company",
                "MPAY": "MPAY",
                "Card Country": "Card Country",
                "Card Holder Name": "Card Holder Name",
                "Card Number": "Card Number",
                "Card Expiry Date": "Card Expiry Date",
                "Month (MM)": "Month (MM)",
                "Card Expiry Year": "Card Expiry Year",
                "Year (YYYY)": "Year (YYYY)",
                "GCC": "GCC"
            }
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            },
            "iwb": {
                "1p_fourth_level_onward": "1% IWB from 4th ~ ∞ level",
                "2p_second_level": "2% IWB from 2nd level",
                "2p_third_level": "2% IWB from 3rd level",
                "20p_first_level": "20% IWB from 1st level",
                "inactive_brand_ambassador": "Inactive Brand Ambassador",
                "active_brand_ambassador": "Active Brand Ambassador"
            },
            "general": {
                "paid_as_rank": "Paid as Rank",
                "active_status": "Active Status",
                "no_of_3_star_director_legs": "# of 3 Star Director Legs",
                "no_of_diamond_legs": "# of Diamond Legs",
                "left_business_volume": "Left Business Volume (BV)",
                "right_business_volume": "Right Business Volume (BV)"
            },
            "commission_and_bonuses": {
                "retail_bonus": "Retail Bonus",
                "iwb": "IWB",
                "tvc": "TVC",
                "mb": "MB",
                "other_bonuses": "Other Bonuses",
                "sub_total": "Sub-total"
            },
            "chp_gbp": {
                "total_shares": "Total Shares"
            },
            "paid_as_ranks": {
                "DRT": "Director",
                "2SDRT": "2-Star Director",
                "3SDRT": "3-Star Director",
                "DM": "Diamond",
                "2SDM": "2-Star Diamond",
                "3SDM": "3-Star Diamond",
                "PSD": "President",
                "2PSD": "2-Star President",
                "3PSD": "3-Star President",
                "CRO": "Crown",
                "2CRO": "2-Star Crown",
                "3CRO": "3-Star Crown"
            },
            "builder_ranks": {
                "builder": "Builder",
                "pro_builder": "Pro Builder",
                "elite_builder": "Elite Builder",
                "ba": "Brand Ambassador"
            },
            "bonus_calculation_fail": {
                "email": {
                    "subject": " IBS Bonus Calculation Failed for PC ( {pay_cycle} ) at {date_time}"
                }
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "This user does not have access to locations module.",
                "resource_not_belong": "This resource not belong to you.",
                "un_authorized": "This action is not authorized",
                "email_unique": "This email already taken.",
                "not-member": "This user is not a member.",
                "invalid-account": "User account is not valid anymore"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "Inactive"
            },
            "dashboard": {
                "pay_leg_is": {
                    "left": "LEFT",
                    "right": "RIGHT"
                }
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA",
                "not-allowed-to-rejoin": "IC/passport number already exists"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "Outermost left downline not found.",
                "no-outer-right": "Outermost right downline not found."
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice has a sales cancellation pending for approval. Please try again after the sales cancellation process is completed.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund.",
                "redemption-exist": "Redemption sale exist for this invoice and need to be cancel first before can proceed."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid.",
                "categories": {
                    "standard": "Standard",
                    "enrolment": "Enrolment",
                    "auto_ship": "Auto Ship",
                    "esac": "eSac",
                    "voucher": "Voucher",
                    "evoucher": "eVoucher",
                    "bundle": "Bundle",
                    "retail": "Retail",
                    "ek_smart": "Ek Smart",
                    "itoken": "iToken"
                },
                "sale-shipping-param-can-not-empty": "{key} is required"
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to resume enrollment.",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "Your cart is empty",
                "checkout": "Proceed to checkout",
                "cannot-checkout": "Unable to checkout",
                "cannot-checkout-epp": "Cannot checkout with EPP products and normal products combined",
                "cannot-checkout-epp-backoffice": "Unable to add {sku}. EPP products and normal products cannot be combined.",
                "cannot-checkout-rental": "Cannot checkout with rental products and normal products combined",
                "cannot-checkout-rental-epp": "Cannot checkout with EPP products and rental products combined",
                "cannot-checkout-rental-exceed": "Cannot checkout with rental product more than one",
                "delivery-stock-location-not-found": "We are unable to deliver to the specified address",
                "virel-referrer-empty": "Your session dose not have a referrer"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "Minimum {cv} {eligibleType} required. Please meet that criteria to proceed with the purchase.",
                "minimum_cv_to_active": "Add {cv} BV to become active for {cw}",
                "minimum_cv_for_ba_enrollment": "Minimum {cv} BV required for BA enrollment. Please meet that criteria to proceed.",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV",
                "amp_sale": "amp BV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in iElken membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "jasper": {
                "jrxml-file-not-found": "Jasper Report (.jrxml) File not found",
                "binary-file-not-found": "Jasper Report Binary (.jasper) File not found",
                "form-not-found": "Jasper Report Selected Form Not Exist.",
                "format-invalid-or-unavailable-found": "Jasper Report Format invalid or unavailable",
                "general-error": "Jasper Report Creation Failed Check Log"
            },
            "qr": {
                "payment": {
                    "process": "Please Wait. We are processing your payment",
                    "redirect": "If you are not redirected in 5 seconds, click the button below"
                }
            },
            "payment": {
                "process": "Please Wait. We are processing your payment",
                "process-processed": "Your payment {status}",
                "already-processed": "This payment has been processed",
                "status-success": "was Successful",
                "status-pending": "is Pending",
                "status-failed": "has Failed",
                "success": "Success",
                "pending": "Pending",
                "failed": {
                    "header_title": "Payment Failed",
                    "webview_body_text": "Your order payment failed. You may click the following button to return to the sales order.",
                    "non_webview_body_text": "Your order payment failed.",
                    "return_button_title": "Return"
                },
                "msg-success": "Thank You",
                "msg-pending": "Your payment is pending, we will inform you once completed",
                "msg-failed": "Please try again",
                "status-successful": "was Successful",
                "redirect": "If you are not redirected in 5 seconds, click the button below",
                "continue": "Continue",
                "empty": "Problem occurs!!!Please contact the Support Team for enquiry",
                "sale-completed": "This sale has already been fully paid.",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "Payment Success",
                    "webview_body_text": "Thank you for your payment. Next, you may click on the following button to complete the order.",
                    "webview_complete_payment_button_title": "Complete Payment",
                    "non_webview_body_text": "Thank you for your payment. Next, you may notify the person who sent you the payment link to confirm the order status.",
                    "non_webview_share_button_title": "Share",
                    "non_webview_with_callback_body_text": "Thank you for your payment. Next, you may click on the following button to return to the order status page.",
                    "non_webview_with_callback_button_title": "Return",
                    "sharer_title": "Elken Global",
                    "sharer_description": "I have successfully paid {currency_iso_code}{total_payment_amount} using {payment_provider_name} for sales order number {sale_document_number}."
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you choose is not eligible for the enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "integration": {
                "yy_not_success": "Data integration from NIBS to Yonyou failed!!!."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation codes to activate your product at {url}."
                },
                "sms": "Please use the following codes to activate your TrueYou product at {url}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            },
            "department": {
                "already_taken": "This \"{value}\" already taken."
            },
            "mi_space": {
                "access_code_fail": "Unable to get the access code"
            },
            "itoken": {
                "title": "iToken",
                "duplicate_values": "Error! please verify the data, you have passed the duplicate data for ( {identifier} ), please check this item ( {data} )",
                "voucher_can_not_be_redeem": "Error! sorry you have selected invalid voucher to redeem",
                "already_redeemed": "The iToken Voucher you are trying to redeem has already been redeemed",
                "select_item_or_click_redeem_later": "Please select iToken redemption items before completing your sales. If you choose not to redeem now, click on the redeem later button.",
                "un_able_to_purchase": "{name} can not be purchased",
                "voucher": {
                    "invalid_redeem_qty": "You have selected {selected_qty} point but max redemption quantity is {qty}, you cannot exceed it",
                    "voucher_points_exceed": "The selected Itoken points for redemption can not be more than the eligible points {point}",
                    "cant_selected_items_in_accumulated": "Error! Sorry you cannot select the items in accumulation",
                    "voucher_id_or_country_id_empty": "Please! make sure either you provide voucher-id or country_id both cannot be empty",
                    "selected_items_empty_in_on_the_spot": "Error! please add the campaign items for redemption",
                    "invalid_selection_item": "Selected items don't belong the given voucher",
                    "location_required": "Error! You need to send the location for item price",
                    "voucher_can_not_be_redeem": "Error! sorry you have selected invalid voucher to redeem"
                },
                "document": {
                    "upload_error": "Submitted file is incorrect. Please download sample file to get correct file template."
                }
            },
            "product_template": {
                "upload_error": "Submitted file is incorrect. Please download sample file to get correct file template."
            },
            "table_update_log": {
                "cannot_insert": "Cannot insert table updates into the table_updates log table"
            },
            "bundle": {
                "member_price_title": "Member Price",
                "member_price_text": "Spare a moment to fill up the member's form and enjoy 30% off at retail price on all products!",
                "retail_price_title": "Retail Price",
                "retail_price_text": "Retail price, 30% more than member price!"
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    },
    "hk": {
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            }
        }
    },
    "id": {
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            }
        }
    },
    "in": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "exception": "Sorry we are unable to process your request, please try again!",
            "reset-password": {
                "sms": "To reset the password for your iBS account, please enter the OTP {otp}, expires {validity} min. {url}",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS login password.  \n            <br>\n            Please enter the one-time password (OTP) : {otp} \n            <br>\n            The OTP only valid for {validity} minutes.  \n            <br><br>\n            {url}\n            If you do not want to reset your password, you may simply ignore or delete this email; your login password will not be changed, and you will still be able to access your member portal.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-security-pin-sent": "We have e-mailed you security pin reset instructions!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS EWallet security pin.  \n            <br>\n            Please login to your member portal follow the steps below:\n            <br>\n            1. Go to <b>My Account</b>.\n            <br>\n            2. Click on <b>e-Wallet Settings</b> tab.\n            <br>\n            3. Click on <b>Reset</b> button and follow through the step by step process.\n            <br><br>\n            If you do not want to reset your security pin, you may simply ignore or delete this email; your security pin will not be changed, and you will still be able to access your e-wallet.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-attempt-max": "You’ve reached the maximum attempt. Please try again later.",
            "reset-attempt-gap": "You are resetting the password too often. Please try again later.",
            "reset-attempt-expire": "You’ve reached the maximum attempt. OTP is invalid/expired"
        },
        "resume_payment": {
            "email": {
                "subject": "Your order {document_number} is waiting for you"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item"
            }
        },
        "email": {
            "welcome": {
                "subject": "Welcome to Elken IBS",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for registering on our IBS system and we welcome you onboard",
                "visit": "Visit IBS",
                "footer": "Thank you for using our Elken IBS!"
            },
            "staff_welcome": {
                "subject": "Welcome to Elken",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for being part of Elken. and welcome on board.",
                "credentials": "please use the following credentials to login in to our IBS.",
                "email": "Email: {email}",
                "password": "Password: {password}",
                "visit": "Visit IBS",
                "footer": "Elken IBS!"
            }
        },
        "enrollment": {
            "email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Welcome to Elken </span>\n            <br><br>\n            \n            Congratulations on taking your first step with us to secure your future and personal financial success. It is the right time and you have made a fantastic choice to be part of us. \n            <br><br>\n            The Elken Global Compensation Plan is designed to be rewarding and sustainable to ensure you have a strong and profitable business. \n            <br><br>\n            We encourage you to take the time to familiarize yourself with the Elken Global Compensation Plan, business tool/management and products to help you build a successful business. As a member, you are entitled to purchase our products at member price. \n            <br><br>\n            Once again, thank you for making the right decision to <span style=\"color: red\">join us</span> . \n            <br><br>\n            To Your Success! \n            <br>\n            The Management Team \n            <br>\n            Email: customerservice@elken.com \n            <br><hr>            \n            Your Login Info<br>\n            Member ID: {iboMemberId}<br><br>Current Password: {password}<br><br>*You can change your password by logging into member portal.\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "Welcome to Elken Global and congratulations on your enrollment! Please log into your iBS: {url} with IBO ID: {iboMemberId} Password: {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "duplicated_enrollment_error": "Failure to complete enrolment due to the provided contact details already exist in our database. Please contact CS."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "iwb": {
                "1p_fourth_level_onward": "1% IWB dari level 4th ~ ∞ ",
                "2p_second_level": "2% IWB dari level ke 2",
                "2p_third_level": "2% dari IWB dari level ke 3",
                "20p_first_level": "20% IWB dari level ke 1",
                "inactive_brand_ambassador": "Brand Ambassador Tidak Aktif",
                "active_brand_ambassador": "Brand Ambassador Aktif"
            },
            "general": {
                "paid_as_rank": "Dibayar sebagai peringkat",
                "active_status": "Status Aktif",
                "no_of_3_star_director_legs": "# dari 3 Star Director Legs",
                "no_of_diamond_legs": "# dari Diamond Legs",
                "left_business_volume": "Business Volume (BV) Kiri",
                "right_business_volume": "Business Volume (BV) Kanan"
            },
            "commission_and_bonuses": {
                "retail_bonus": "Bonus Retail",
                "iwb": "IWB",
                "tvc": "TVC",
                "mb": "MB",
                "other_bonuses": "Bonus Lainnya",
                "sub_total": "Sub-total"
            },
            "chp_gbp": {
                "total_shares": "Total Saham"
            },
            "paid_as_ranks": {
                "DRT": "Director",
                "2SDRT": "2-Star Director",
                "3SDRT": "3-Star Director",
                "DM": "Diamond",
                "2SDM": "2-Star Diamond",
                "3SDM": "3-Star Diamond",
                "PSD": "President",
                "2PSD": "2-Star President",
                "3PSD": "3-Star President",
                "CRO": "Crown",
                "2CRO": "2-Star Crown",
                "3CRO": "3-Star Crown"
            },
            "builder_ranks": {
                "builder": "Builder",
                "pro_builder": "Pro Builder",
                "elite_builder": "Elite Builder",
                "ba": "Brand Ambassador"
            },
            "bonus_statement": {
                "header_title": "Pernyataan Bonus",
                "statement_date": "Tanggal Pernyataan",
                "member_code": "Kode Member",
                "name": "Nama",
                "tax_number": "Tax No.",
                "highest_rank": "Peringkat Tertinggi",
                "effective_rank": "Peringkat Efektif",
                "address": "Alamat",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Bonus Retail",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Dana Mobil & Rumah",
                "incentive": "Insentif",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Dikurangi : Pajak",
                "net_bonus_payable_before_bank_charges": "Bonus Bersih dibayarkan (sebelum biaya bank)",
                "withdrawal_bank_charges_disclaimer": "* Selama penarikan komisi, %s %s biaya pengiriman akan dikenakan oleh Perusahaan. Harap perhatikan bahwa bank perantara juga akan membebankan beberapa biaya sehingga jumlah yang sebenarnya harus dibayar mungkin tidak sesuai dengan jumlah pernyataan atau jumlah wallet.",
                "infinity_welcome_bonus_details": "Detail Infininity Welcome Bonus",
                "number": "No.",
                "join_date": "Tanggal Bergabung",
                "type": "Jenis",
                "level": "Level",
                "local_amount": "Jumlah dalam mata uang lokal (%s)",
                "nett": "Nett",
                "tvc_details": "Detail TVC",
                "batch": "Batch",
                "carry_forward": "Diteruskan",
                "this_week_bv": "BV Minggu Ini",
                "this_week_ops": "OPS Minggu Ini",
                "calculation_bv": "Perhitungan BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "Dilanjutkan",
                "value_per_point": "Nilai per Poin",
                "matching_bonus_details": "Detail Matching Bonus",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "This user does not have access to locations module.",
                "resource_not_belong": "This resource not belong to you.",
                "un_authorized": "This action is not authorized",
                "email_unique": "This email already taken.",
                "not-member": "This user is not a member.",
                "invalid-account": "User account is not valid anymore"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "Tidak Aktif"
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "Downline kiri yang paling luar tidak dapat ditemui.",
                "no-outer-right": "Downline kanan yang paling luar tidak dapat ditemui."
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice was under sales cancellations process.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid."
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to resume enrollment.",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "Keranjang anda kosong",
                "checkout": "Lanjutkan ke pembayaran",
                "cannot-checkout": "Tidak dapat melakukan pembayaran",
                "cannot-checkout-epp": "Tidak dapat melakukan pembayaran dengan produk EPP dan produk normal gabungan.",
                "cannot-checkout-epp-backoffice": "Tidak dapat menambahkan {sku}. Produk EPP dan produk normal tidak dapat digabungkan.",
                "delivery-stock-location-not-found": "Kami tidak dapat mengirim ke alamat yang ditentukan",
                "virel-referrer-empty": "Dosis sesi Anda tidak memiliki pengarah"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "Minimal {cv} {eligibleType} diperlukan, Harap ikuti persyaratan tersebut untuk melanjutkan pembelian",
                "minimum_cv_to_active": "Tambahkan {cv} agar menjadi aktif untuk {cw}",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in Elken Global membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "qr": {
                "payment": {
                    "process": "Please Wait. We are processing your payment",
                    "redirect": "If you are not redirected in 5 seconds, click the button below"
                }
            },
            "payment": {
                "process": "Mohon tunggu. Kami sedang memproses pembayaran Anda",
                "process-processed": "Pembayaran anda {status}",
                "already-processed": "Pembayaran ini telah diproses",
                "status-success": "Berhasil",
                "status-pending": "sedang menunggu keputusan",
                "status-failed": "telah gagal",
                "success": "Berhasil",
                "pending": "tertunda",
                "failed": {
                    "header_title": "Pembayaran pesanan Anda gagal.",
                    "webview_body_text": "Pembayaran pesanan Anda gagal. Anda dapat mengklik tombol berikut untuk kembali ke pesanan penjualan.",
                    "non_webview_body_text": "Pembayaran anda gagal.",
                    "return_button_title": "Kembali"
                },
                "msg-success": "Terima kasih",
                "msg-pending": "Pembayaran Anda tertunda, kami akan memberi tahu Anda setelah selesai",
                "msg-failed": "Silakan coba lagi",
                "status-successful": "Berhasil",
                "redirect": "Jika Anda tidak dialihkan dalam 5 detik, klik tombol di bawah",
                "continue": "Terus",
                "empty": "Terjadi masalah !!! Silakan hubungi Tim Dukungan untuk pertanyaan Pembayaran gagal",
                "sale-completed": "Penjualan ini sudah lunas.",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "pembayaran berhasil",
                    "webview_body_text": "Terima kasih atas pembayaran Anda. Selanjutnya, Anda dapat mengklik tombol berikut untuk menyelesaikan pesanan.",
                    "webview_complete_payment_button_title": "Selesaikan Pembayaran",
                    "non_webview_body_text": "Terima kasih atas pembayaran Anda. Selanjutnya, Anda dapat memberi tahu orang yang mengirimi Anda tautan pembayaran untuk mengonfirmasi status pesanan.",
                    "non_webview_share_button_title": "Bagikan",
                    "non_webview_with_callback_body_text": "Terima kasih atas pembayaran Anda. Selanjutnya, Anda dapat mengklik tombol berikut untuk kembali ke halaman status pesanan.",
                    "non_webview_with_callback_button_title": "Kembali",
                    "sharer_title": "Elken Global",
                    "sharer_description": "Saya telah berhasil membayar {currency_iso_code}{total_payment_amount} menggunakan {payment_provider_name} untuk nomor pesanan penjualan {sale_document_number}."
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you choose is not eligible for the enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation code to activate you saliva collection kit online."
                },
                "sms": "Your TrueYou activation code is {code}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    },
    "kh": {
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            }
        }
    },
    "km": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "exception": "Sorry we are unable to process your request, please try again!",
            "reset-password": {
                "sms": "To reset the password for your iBS account, please enter the OTP {otp}, expires {validity} min. {url}",
                "email": "\n            ជូនចំពោះ {name}, \n            <br><br>\n        \n            យយើងបានទទួលការជូនដំណឹងមួយដែលអ្នកចង់កំណត់ពាក្យសម្ងាត់ចូលអ៊ីនធីស៍របស់អ្នក។ សូមបញ្ចូលពាក្យសម្ងាត់ម្តង (OTP): {otp} \n            <br>\n            OTP មានសុពលភាពត្រឹមតែ {validity} នាទីប៉ុណ្ណោះ។\n            <br><br>\n            {url}\n            បើសិនជាអ្នក លែងចង់ធ្វើការផ្លាស់ប្តូរលេខកូដសំងាត់ អ្នកគ្រាន់តែទុកចោលឬលុបចោលអ៊ីមែលនេះ។   \n            <br><br>\n            ដើម្បីភាពជោគជ័យរបស់អ្នក!\n            <br><br>\n            \n            ក្រុមអ្នកគាំទ្រ\n            <br><br>\n            <hr>\n            <br><br>\n            គេហទំព័រ :<a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            អ៊ីមែល :<a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - សារនេះត្រូវបានបង្កើតដោយស្វ័យប្រវត្តិ។សូមកុំឆ្លើយតប។- - - ></div>\n        "
            },
            "reset-security-pin-sent": "We have e-mailed you security pin reset instructions!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS EWallet security pin.  \n            <br>\n            Please login to your member portal follow the steps below:\n            <br>\n            1. Go to <b>My Account</b>.\n            <br>\n            2. Click on <b>e-Wallet Settings</b> tab.\n            <br>\n            3. Click on <b>Reset</b> button and follow through the step by step process.\n            <br><br>\n            If you do not want to reset your security pin, you may simply ignore or delete this email; your security pin will not be changed, and you will still be able to access your e-wallet.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-attempt-max": "You’ve reached the maximum attempt. Please try again later.",
            "reset-attempt-gap": "You are resetting the password too often. Please try again later.",
            "reset-attempt-expire": "You’ve reached the maximum attempt. OTP is invalid/expired"
        },
        "resume_payment": {
            "email": {
                "subject": "Your order {document_number} is waiting for you"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item"
            }
        },
        "email": {
            "welcome": {
                "subject": "Welcome to Elken IBS",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for registering on our IBS system and we welcome you onboard",
                "visit": "Visit IBS",
                "footer": "Thank you for using our Elken IBS!"
            },
            "staff_welcome": {
                "subject": "Welcome to Elken",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for being part of Elken. and welcome on board.",
                "credentials": "please use the following credentials to login in to our IBS.",
                "email": "Email: {email}",
                "password": "Password: {password}",
                "visit": "Visit IBS",
                "footer": "Elken IBS!"
            }
        },
        "enrollment": {
            "email": {
                "subject": "ស្វាគមន៍មកកាន់អែលខេន (ELKEN)",
                "content": "\n            ជូនចំពោះ {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">ស្វាគមន៍មកកាន់អែលខេន (ELKEN)</span>\n            <br><br>\n            \n            យើងខ្ញុំសូមអបអរសាទរអ្នកក្នុងការទិញទំនិញពីពួកយើង។ \n            <br><br>\n            អ្នកបានជ្រើសរើសជម្រើសមួយដ៍ត្រឹមត្រូវក្នុងការក្លាយជាអតិថិជនរបស់យើង។ \n            <br><br>\n            សូមយកពេលវេលាដើម្បីយល់ឱ្យបានច្បាស់ ជាមួយនឹងផលិតផលរបស់យើងដោយខ្លួនឯង។ \n            <br><br>\n            ជាថ្មីម្តងទៀតយើងខ្ញុំសូមអរគុណសម្រាប់ការគាំទ្រនិងការទិញរបស់អ្នក។ \n            <br><br>\n            ដើម្បីភាពជោគជ័យរបស់អ្នក! \n            <br>\n            ក្រុមអ្នកគ្រប់គ្រង \n            <br><br>\n            គេហទំព័រ : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            អ៊ីមែល : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><hr>            \n            Your Login Info<br>\n            Member ID: {iboMemberId}<br><br>Current Password: {password}<br><br>*You can change your password by logging into member portal.\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - សារនេះត្រូវបានបង្កើតដោយស្វ័យប្រវត្តិ។សូមកុំឆ្លើយតប - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "Welcome to Elken Global and congratulations on your enrollment! Please log into your iBS: {url} with IBO ID: {iboMemberId} Password: {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "duplicated_enrollment_error": "Failure to complete enrolment due to the provided contact details already exist in our database. Please contact CS."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "iwb": {
                "1p_fourth_level_onward": "1% IWB from 4th ~ ∞ level",
                "2p_second_level": "2% IWB from 2nd level",
                "2p_third_level": "2% IWB from 3rd level",
                "20p_first_level": "20% IWB from 1st level",
                "inactive_brand_ambassador": "Inactive Brand Ambassador",
                "active_brand_ambassador": "Active Brand Ambassador"
            },
            "general": {
                "paid_as_rank": "Paid as Rank",
                "active_status": "Active Status",
                "no_of_3_star_director_legs": "# of 3 Star Director Legs",
                "no_of_diamond_legs": "# of Diamond Legs",
                "left_business_volume": "Left Business Volume (BV)",
                "right_business_volume": "Right Business Volume (BV)"
            },
            "commission_and_bonuses": {
                "retail_bonus": "Retail Bonus",
                "iwb": "IWB",
                "tvc": "TVC",
                "mb": "MB",
                "other_bonuses": "Other Bonuses",
                "sub_total": "Sub-total"
            },
            "chp_gbp": {
                "total_shares": "Total Shares"
            },
            "paid_as_ranks": {
                "DRT": "Director",
                "2SDRT": "2-Star Director",
                "3SDRT": "3-Star Director",
                "DM": "Diamond",
                "2SDM": "2-Star Diamond",
                "3SDM": "3-Star Diamond",
                "PSD": "President",
                "2PSD": "2-Star President",
                "3PSD": "3-Star President",
                "CRO": "Crown",
                "2CRO": "2-Star Crown",
                "3CRO": "3-Star Crown"
            },
            "builder_ranks": {
                "builder": "Builder",
                "pro_builder": "Pro Builder",
                "elite_builder": "Elite Builder",
                "ba": "Brand Ambassador"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "This user does not have access to locations module.",
                "resource_not_belong": "This resource not belong to you.",
                "un_authorized": "This action is not authorized",
                "email_unique": "This email already taken.",
                "not-member": "This user is not a member.",
                "invalid-account": "User account is not valid anymore"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "Inactive"
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "Outermost left downline not found.",
                "no-outer-right": "Outermost right downline not found."
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice was under sales cancellations process.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid."
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to resume enrollment.",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "Your cart is empty",
                "checkout": "Proceed to checkout",
                "cannot-checkout": "Unable to checkout",
                "cannot-checkout-epp": "Cannot checkout with EPP products and normal products combined",
                "cannot-checkout-epp-backoffice": "Unable to add {sku}. EPP products and normal products cannot be combined.",
                "delivery-stock-location-not-found": "We are unable to deliver to the specified address",
                "virel-referrer-empty": "Your session dose not have a referrer"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "ទាមទារអប្បបរមា {cv} {eligibleType}, សូមបំពេញតាមលក្ខណៈវិនិច្ឆ័យនោះដើម្បីបន្តការទិញ។",
                "minimum_cv_to_active": "បន្ថែម {cv} BV អោយសកម្មសំរាប់ {cw}",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in Elken Global membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "qr": {
                "payment": {
                    "process": "Please Wait. We are processing your payment",
                    "redirect": "If you are not redirected in 5 seconds, click the button below"
                }
            },
            "payment": {
                "process": "សូមរង់ចាំ។ យើងកំពុងដំណើរការការទូទាត់របស់អ្នក",
                "process-processed": "ការទូទាត់របស់អ្នក៖ {status}",
                "already-processed": "ការទូទាត់នេះត្រូវបានដំណើរការ",
                "status-success": "គឺទទួលបានជោគជ័យ",
                "status-pending": "កំពុងរង់ចាំ",
                "status-failed": "បានបរាជ័យ",
                "success": "ទទួលបានជោគជ័យ",
                "pending": "រង់ចាំ",
                "failed": {
                    "header_title": "ការទូទាត់បានបរាជ័យ",
                    "webview_body_text": "ការទូទាត់ការបញ្ជាទិញរបស់អ្នកបានបរាជ័យ។ អ្នកអាចចុចប៊ូតុងខាងក្រោមដើម្បីត្រឡប់ទៅ sale order វិញ។",
                    "non_webview_body_text": "ការទូទាត់ការបញ្ជាទិញរបស់អ្នកបានបរាជ័យ។",
                    "return_button_title": "ត្រឡប់"
                },
                "msg-success": "សូមអរគុណ",
                "msg-pending": "ការទូទាត់របស់អ្នកមិនទាន់សម្រេចទេយើងនឹងជូនដំណឹងអ្នកនៅពេលរួចរាល់",
                "msg-failed": "សូម​ព្យាយាម​ម្តង​ទៀត",
                "status-successful": "គឺទទួលបានជោគជ័យ",
                "redirect": "ប្រសិនបើអ្នកមិនត្រូវបានទទួលក្នុងរយៈពេល 5 វិនាទីទេសូមចុចប៊ូតុងខាងក្រោម",
                "continue": "បន្ត",
                "empty": "មានបញ្ហាកើតឡើង !!! សូមទាក់ទងក្រុមគាំទ្រដើម្បីសាកសួរ",
                "sale-completed": "ការលក់នេះត្រូវបានបង់រួចរាល់ហើយ។",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "ការទូទាត់បានជោគជ័យ",
                    "webview_body_text": "សូម​អរគុណ​ចំពោះ​ការ​បង់ប្រាក់​របស់​អ្នក​។ បន្ទាប់អ្នកអាចចុចលើប៊ូតុងខាងក្រោមដើម្បីបំពេញការបញ្ជាទិញ។",
                    "webview_complete_payment_button_title": "ការទូទាត់ពេញលេញ",
                    "non_webview_body_text": "សូម​អរគុណ​ចំពោះ​ការ​ទូរទាត់ប្រាក់​របស់​អ្នក​។ បន្ទាប់មក អ្នកអាចជូនដំណឹងដល់អ្នកដែលបានផ្ញើតំណនៃការទូទាត់ប្រាក់មកអ្នកដើម្បីបញ្ជាក់ពីស្ថានភាពនៃការបញ្ជាទិញ។",
                    "non_webview_share_button_title": "ចែករំលែក",
                    "non_webview_with_callback_body_text": "សូម​អរគុណ​ចំពោះ​ការ​ទូទាត់ប្រាក់​របស់​អ្នក​។ បន្ទាប់អ្នកអាចចុចលើប៊ូតុងខាងក្រោមដើម្បីត្រឡប់ទៅទំព័របញ្ជាទិញ។",
                    "non_webview_with_callback_button_title": "ត្រឡប់",
                    "sharer_title": "Elken Global",
                    "sharer_description": "\"ខ្ញុំបានបង់ប្រាក់ដោយជោគជ័យ {currency_iso_code}{total_payment_amount} using {payment_provider_name} សម្រាប់លេខកូដបញ្ជាទិញ {sale_document_number}.\""
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you choose is not eligible for the enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation code to activate you saliva collection kit online."
                },
                "sms": "Your TrueYou activation code is {code}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    },
    "ms": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "exception": "Sorry we are unable to process your request, please try again!",
            "reset-password": {
                "sms": "Untuk menetapkan semula kata laluan anda, sila masukkan OTP {otp}, tamat dalam masa {validity} minit. {url}",
                "email": "\n            Salam Sejahtera {name}, \n            <br><br>\n        \n            Kami menerima notifikasi bahawa anda ingin set semula kata laluan iBS anda. Sila masukkan kata laluan satu kali (OTP) anda: {otp} \n            <br>\n            OTP tersebut hanya boleh digunapakai di dalam masa {validity} minit sahaja.\n            <br><br>\n            {url}\n            Jika anda tidak ingin set semula kata laluan anda, sila abaikan e-mel ini.  \n            <br><br>\n            Demi Kejayaan Anda! \n            <br><br>\n            \n            Pasukan Bantuan \n            <br><br>\n            <hr>\n            <br><br>\n            Laman Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Emel : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - Mesej ini dijana secara automatik. Tidak perlu membalas mesej ini - - - ></div>\n        "
            },
            "reset-security-pin-sent": "We have e-mailed you security pin reset instructions!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS EWallet security pin.  \n            <br>\n            Please login to your member portal follow the steps below:\n            <br>\n            1. Go to <b>My Account</b>.\n            <br>\n            2. Click on <b>e-Wallet Settings</b> tab.\n            <br>\n            3. Click on <b>Reset</b> button and follow through the step by step process.\n            <br><br>\n            If you do not want to reset your security pin, you may simply ignore or delete this email; your security pin will not be changed, and you will still be able to access your e-wallet.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-attempt-max": "You’ve reached the maximum attempt. Please try again later.",
            "reset-attempt-gap": "You are resetting the password too often. Please try again later.",
            "reset-attempt-expire": "You’ve reached the maximum attempt. OTP is invalid/expired"
        },
        "resume_payment": {
            "email": {
                "subject": "Your order {document_number} is waiting for you"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item"
            }
        },
        "email": {
            "welcome": {
                "subject": "Welcome to Elken IBS",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for registering on our IBS system and we welcome you onboard",
                "visit": "Visit IBS",
                "footer": "Thank you for using our Elken IBS!"
            },
            "staff_welcome": {
                "subject": "Welcome to Elken",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for being part of Elken. and welcome on board.",
                "credentials": "please use the following credentials to login in to our IBS.",
                "email": "Email: {email}",
                "password": "Password: {password}",
                "visit": "Visit IBS",
                "footer": "Elken IBS!"
            }
        },
        "enrollment": {
            "email": {
                "subject": "Selamat datang ke ELKEN!",
                "content": "\n            Kepada {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Selamat datang ke ELKEN!</span>\n            <br><br>\n            \n            Tahniah kerana mengambil langkah pertama menyertai kami untuk menjamin masa depan dan kejayaan kewangan peribadi anda. Ia adalah masa yang sesuai dan anda telah membuat pilihan yang terbaik untuk menjadi sebahagian daripada kami. \n            <br><br>\n            Pelan Pemasaran Elken Global direka untuk memberi ganjaran dan kestabilan untuk memastikan anda mempunyai perniagaan yang kukuh dan menguntungkan. \n            <br><br>\n            Kami menggalakkan anda untuk mengambil masa untuk membiasakan diri dengan Pelan Pemasaran Elken Global, alat bantu Perniagaan/Pengurusan Perniagaan serta pengetahuan produk untuk membantu anda membina perniagaan yang berjaya. Sebagai ahli, anda layak untuk membeli produk kami pada harga ahli. \n            <br><br>\n            Sekali lagi, terima kasih kerana membuat keputusan yang tepat untuk menyertai kami. \n            <br><br>\n            Demi Kejayaan Anda! \n            <br>\n            Pihak Pengurusan\n            <br><br>\n            Laman Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><hr>            \n            Maklumat Log Masuk Anda<br>\n            ID Keahlian: {iboMemberId}<br><br>Kata Laluan: {password}<br><br>*Anda boleh menukar kata laluan anda dengan log masuk ke dalam portal ahli.\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - Mesej ini telah dijana secara automatik. Sila jangan balas kembali. - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "Selamat datang & tahniah! Sila log masuk portal iBS: {url} Maklumat log masuk anda, IBO ID: {iboMemberId} kata laluan: {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "duplicated_enrollment_error": "Failure to complete enrolment due to the provided contact details already exist in our database. Please contact CS."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "countries_dynamic_content": {
            "address": {
                "Permanent": "Permanent",
                "Correspondence": "Correspondence",
                "Shipping 1": "Shipping 1",
                "Shipping 2": "Shipping 1",
                "Address 1": "Address 1",
                "Address 2": "Address 2",
                "Address 3": "Address 3",
                "Address 4": "Address 4",
                "postcode": "Postcode",
                "Postcode": "Postcode",
                "state": "State",
                "State": "State",
                "city": "City",
                "City": "City",
                "country": "Country",
                "Country": "Country"
            },
            "member_payout_options": {
                "BANK": "BANK",
                "Bank Country": "Bank Country",
                "Bank Name": "Bank Name",
                "A/C Holder Name": "A/C Holder Name",
                "Swift Code": "Swift Code",
                "Account Type": "Account Type",
                "Bank Account No": "Bank Account No",
                "Bank Account IC": "Bank Account IC",
                "Payout Company": "Payout Company",
                "MPAY": "MPAY",
                "Card Country": "Card Country",
                "Card Holder Name": "Card Holder Name",
                "Card Number": "Card Number",
                "Card Expiry Date": "Card Expiry Date",
                "Month (MM)": "Month (MM)",
                "Card Expiry Year": "Card Expiry Year",
                "Year (YYYY)": "Year (YYYY)",
                "GCC": "GCC"
            }
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "iwb": {
                "1p_fourth_level_onward": "1% IWB dari 4 ~ peringkat ∞ ",
                "2p_second_level": "2% IWB dari  peringkat 2",
                "2p_third_level": "2% IWB dari peringkat 3",
                "20p_first_level": "20% IWB dari  peringkat 1",
                "inactive_brand_ambassador": "Duta Jenama Tidak Aktif",
                "active_brand_ambassador": "Duta Jenama Aktif"
            },
            "general": {
                "paid_as_rank": "Paid as Rank",
                "active_status": "Status Aktif",
                "no_of_3_star_director_legs": "# Kaki 3 Star Director ",
                "no_of_diamond_legs": "# Kaki Diamond",
                "left_business_volume": "Business Volume (BV) Kiri",
                "right_business_volume": "Business Volume (BV) Kanan"
            },
            "commission_and_bonuses": {
                "retail_bonus": "Bonus Runcit",
                "iwb": "IWB",
                "tvc": "TVC",
                "mb": "MB",
                "other_bonuses": "Bonus Lain",
                "sub_total": "Jumlah kecil"
            },
            "chp_gbp": {
                "total_shares": "Jumlah Saham"
            },
            "paid_as_ranks": {
                "DRT": "Director",
                "2SDRT": "2-Star Director",
                "3SDRT": "3-Star Director",
                "DM": "Diamond",
                "2SDM": "2-Star Diamond",
                "3SDM": "3-Star Diamond",
                "PSD": "President",
                "2PSD": "2-Star President",
                "3PSD": "3-Star President",
                "CRO": "Crown",
                "2CRO": "2-Star Crown",
                "3CRO": "3-Star Crown"
            },
            "builder_ranks": {
                "builder": "Builder",
                "pro_builder": "Pro Builder",
                "elite_builder": "Elite Builder",
                "ba": "Brand Ambassador"
            },
            "bonus_statement": {
                "header_title": "Penyata Bonus",
                "statement_date": "Tarikh Penyata",
                "member_code": "Kod Ahli",
                "name": "Nama",
                "tax_number": "No. Cukai",
                "highest_rank": "Pangkat Tertinggi",
                "effective_rank": "Pangkat Efektif",
                "address": "Alamat",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Bonus Kasar",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Bonus Aluan Infiniti",
                "retail_bonus": "Bonus Runcit",
                "team_volume_commission": "Komisen Jumlah Pasukan",
                "matching_bonus": "Bonus Padanan",
                "car_house_fund": "Tabung Rumah & Kereta",
                "incentive": "Insentif",
                "global_pool_bank": "Tabung Bank Global",
                "total_gross_bonus": "Jumlah Bonus Kasar",
                "less_wht": "Tolak : WHT",
                "net_bonus_payable_before_bank_charges": "Bayaran Bonus Bersih (sebelum caj bank)",
                "withdrawal_bank_charges_disclaimer": "* Semasa pengeluaran komisen, caj kiriman wang %s %s akan dikenakan oleh Syarikat. Harap maklum bahawa bank perantara juga akan mengenakan sejumlah yuran, oleh itu jumlah yang perlu dibayar sebenarnya tidak sama dengan jumlah penyata atau jumlah dompet.",
                "infinity_welcome_bonus_details": "Butiran Bonus Aluan Infiniti",
                "number": "No.",
                "join_date": "Tarikh Menyertai",
                "type": "Jenis",
                "level": "Peringkat",
                "local_amount": "Amaun Lokal (%s)",
                "nett": "Net",
                "tvc_details": "Maklumat TVC",
                "batch": "Kelompok",
                "carry_forward": "Bawa Depan",
                "this_week_bv": "BV Minggu Ini ",
                "this_week_ops": "OPS Minggu Ini ",
                "calculation_bv": "Pengiraan BV",
                "tvc_point": "Mata",
                "flush": "Pengosongan",
                "carry_over": "Bawa Kedepan",
                "value_per_point": "Nilai setiap Mata",
                "matching_bonus_details": "Butiran Bonus Padanan",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Mata",
                "tb_point": "Mata TB",
                "iwb_nett_usd": "Net (US$)",
                "usd": "US$"
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "This user does not have access to locations module.",
                "resource_not_belong": "This resource not belong to you.",
                "un_authorized": "This action is not authorized",
                "email_unique": "This email already taken.",
                "not-member": "This user is not a member.",
                "invalid-account": "User account is not valid anymore"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "Tidak Aktif"
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "Outermost left downline not found.",
                "no-outer-right": "Outermost right downline not found."
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice was under sales cancellations process.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid."
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to resume enrollment.",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "Troli anda kosong",
                "checkout": "Teruskan untuk daftar keluar",
                "cannot-checkout": "Daftar keluar tidak dapat dilakukan",
                "cannot-checkout-epp": "Daftar keluar dengan penggabungan produk EPP dan produk biasa adalah tidak dibolehkan.",
                "cannot-checkout-epp-backoffice": "Penambahan tidak dapat dilakukan {sku} produk EPP dan produk normal tidak boleh digabungkan.",
                "delivery-stock-location-not-found": "Penghantaran ke alamat ini tidak dapat dilakukan",
                "virel-referrer-empty": "Sesi anda tidak mempunyai seseorang untuk dirujuk"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "Minimum {cv} {eligibleType} diperlukan, Sila memenuhi syarat berkenaan untuk pembelian anda",
                "minimum_cv_to_active": "Menambahkan {cv} BV untuk pengaktifan {cw}",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in Elken Global membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "qr": {
                "payment": {
                    "process": "Please Wait. We are processing your payment",
                    "redirect": "If you are not redirected in 5 seconds, click the button below"
                }
            },
            "payment": {
                "process": "Sila Tunggu. Bayaran anda sedang diproses",
                "process-processed": "Bayaran ada {status}",
                "already-processed": "Bayaran ini telah diproses",
                "status-success": "Telah berjaya",
                "status-pending": "Belum selesai",
                "status-failed": "Telah gagal",
                "success": "Berjaya",
                "pending": "Belum selesai",
                "failed": {
                    "header_title": "Bayaran Tidak Berjaya",
                    "webview_body_text": "Pesanan bayaran anda tidak berjaya. Tekan butan berikutnya untuk kembali ke bahagian pesanan jualan.",
                    "non_webview_body_text": "Pesanan bayaran anda tidak berjaya",
                    "return_button_title": "Kembali"
                },
                "msg-success": "Terima Kasih",
                "msg-pending": "Bayaran anda belum lengkap. Kami akan maklumkan anda setelah selesai",
                "msg-failed": "Sila cuba lagi",
                "status-successful": "Telah berjaya",
                "redirect": "Tekan butang dibawah ini jika anda tidak beralih dalam 5 saat.",
                "continue": "Teruskan",
                "empty": "Masalah dikesan!!! Hubungi Bahagian Sokongan untuk sebarang pertanyaan",
                "sale-completed": "Jualan ini telah dibayar sepenuhnya",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "Pembayaran berjaya",
                    "webview_body_text": "Terima kasih atas bayaran anda. Sekarang tekan butang berikut untuk lengkapkan pesanan.",
                    "webview_complete_payment_button_title": "Bayaran lengkap",
                    "non_webview_body_text": "Terima kasih atas bayaran anda. Sekarang, maklumkan kepada penghantar pautan bayaran untuk mengesahkan status pesanan.",
                    "non_webview_share_button_title": "Saham",
                    "non_webview_with_callback_body_text": "Terima kasih atas bayaran anda. Sekarang, sila tekan butang berikut untuk kembali ke halaman status pesanan.",
                    "non_webview_with_callback_button_title": "Kembali",
                    "sharer_title": "Elken Global",
                    "sharer_description": "Saya berjaya membuat pembayaran {currency_iso_code}{total_payment_amount} menggunakan {payment_provider_name} untuk nombor pesanan jualan {sale_document_number}."
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you choose is not eligible for the enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation code to activate you saliva collection kit online."
                },
                "sms": "Your TrueYou activation code is {code}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    },
    "my": {
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_malaysia_us_only": "{report} report is only available for Malaysia and USA",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item"
            }
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            }
        }
    },
    "th": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "exception": "Sorry we are unable to process your request, please try again!",
            "reset-password": {
                "sms": "To reset the password for your iBS account, please enter the OTP {otp}, expires {validity} min. {url}",
                "email": "\n            เรียน คุณ {name}, \n            <br><br>\n        \n            เราได้รับการแจ้งเตือนว่าคุณต้องการตั้งรหัสผ่านสำหรับเข้าสู่ระบบ iBS ของคุณใหม่ โปรดป้อนรหัสผ่านแบบครั้งเดียว (OTP): {otp} \n            <br>\n            OTP ใช้ได้เฉพาะเวลา {validity} นาที\n            <br><br>\n            {url}\n            หากท่านไม่ต้องการตั้งรหัสผ่านใหม่ \n            <br>\n            กรุณาลบอีเมล์ฉบับนี้และไม่ต้องดำเนินการใดๆ\n            <br>\n            และท่านจะสามารถเข้าระบบสำนักงานออนไลน์ของสมาชิกได้โดยใช้รหัสผ่านเดิม\n            <br><br>\n            ขอแสดงความยินดีกับความสำเร็จของท่านล่วงหน้า! \n            <br><br>\n            \n            ทีมงานสนับสนุน \n            <br><br>\n            <hr>\n            <br><br>\n            เว็บไซต์ : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            อีเมล์ : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - อีเมล์นี้ถูกส่งจากระบบอัตโนมัติ โปรดอย่าตอบกลับอีเมล์นี้ - - - ></div>\n        "
            },
            "reset-security-pin-sent": "We have e-mailed you security pin reset instructions!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS EWallet security pin.  \n            <br>\n            Please login to your member portal follow the steps below:\n            <br>\n            1. Go to <b>My Account</b>.\n            <br>\n            2. Click on <b>e-Wallet Settings</b> tab.\n            <br>\n            3. Click on <b>Reset</b> button and follow through the step by step process.\n            <br><br>\n            If you do not want to reset your security pin, you may simply ignore or delete this email; your security pin will not be changed, and you will still be able to access your e-wallet.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-attempt-max": "You’ve reached the maximum attempt. Please try again later.",
            "reset-attempt-gap": "You are resetting the password too often. Please try again later.",
            "reset-attempt-expire": "You’ve reached the maximum attempt. OTP is invalid/expired"
        },
        "resume_payment": {
            "email": {
                "subject": "Your order {document_number} is waiting for you"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item"
            }
        },
        "email": {
            "welcome": {
                "subject": "Welcome to Elken IBS",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for registering on our IBS system and we welcome you onboard",
                "visit": "Visit IBS",
                "footer": "Thank you for using our Elken IBS!"
            },
            "staff_welcome": {
                "subject": "Welcome to Elken",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for being part of Elken. and welcome on board.",
                "credentials": "please use the following credentials to login in to our IBS.",
                "email": "Email: {email}",
                "password": "Password: {password}",
                "visit": "Visit IBS",
                "footer": "Elken IBS!"
            }
        },
        "enrollment": {
            "email": {
                "subject": "ยินดีต้อนรับสู่เอลเคน",
                "content": "\n            เรียน คุณ {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">ยินดีต้อนรับสู่เอลเคน</span>\n            <br><br>\n            \n            ขอแสดงความยินดีต่อท่านที่ท่านตัดสินใจเลือกก้าวไปพร้อมกับเราเพื่ออนาคตที่มั่นคงและเ พื่อประสบความสำเร็จทางการเงิน \n            <br><br>\n            แผนการตลาดไอเอลเคน ถูกออกแบบมาเพื่อจ่ายผลตอบแทนให้กับนักธุรกิจเพื่อให้ท่านได้ก้าวเดินไปข้างหน้าอย่าง มั่นคง \n            <br><br>\n            ขอให้ท่านใช้เวลาในการศึกษาและทำความคุ้นเคยกับแผนการจ่ายผลตอบแทนไอเอลเคน รวมไปถึงเครื่องมือทางธุรกิจ ระบบการจัดการและผลิตภัณฑ์ เพื่อต่อยอดให้ธุรกิจของท่านประสบความสำเร็จในภายภาคหน้า ทั้งนี้ท่านสมาชิกสามารถซื้อผลิตภัณฑ์ได้ในราคาสมาชิก \n            <br><br>\n            ขอขอบคุณอีกครั้งที่ท่านได้เลือกเข้าร่วมธุรกิจกับเรา. \n            <br><br>\n            ขอแสดงความยินดีกับความสำเร็จของท่านล่วงหน้า! \n            <br>\n            คณะผู้บริหาร \n            <br><br>\n            เว็บไซต์: <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            อีเมล์: <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><hr>            \n            ข้อมูลล็อกอินของท่าน<br>\n            รหัสสมาชิก: {iboMemberId}<br><br>รหัสผ่านปัจจุบัน: {password}<br><br>*านสามารถเปลี่ยนแปลงรหัสผ่านของท่าน โดยล็อกอินเข้าไปที่หน้าสมาชิก\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - อีเมล์นี้ถูกส่งจากระบบอัตโนมัติ โปรดอย่าตอบกลับอีเมล์นี้ - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "Welcome to iElken and congratulations on your enrollment! Please log into your iBS: {url} with IBO ID: {iboMemberId} Password: {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "duplicated_enrollment_error": "Failure to complete enrolment due to the provided contact details already exist in our database. Please contact CS."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "countries_dynamic_content": {
            "address": {
                "Permanent": "Permanent",
                "Correspondence": "Correspondence",
                "Shipping 1": "Shipping 1",
                "Shipping 2": "Shipping 1",
                "Address 1": "Address 1",
                "Address 2": "Address 2",
                "Address 3": "Address 3",
                "Address 4": "Address 4",
                "postcode": "Postcode",
                "Postcode": "Postcode",
                "state": "State",
                "State": "State",
                "city": "City",
                "City": "City",
                "country": "Country",
                "Country": "Country"
            },
            "member_payout_options": {
                "BANK": "BANK",
                "Bank Country": "Bank Country",
                "Bank Name": "Bank Name",
                "A/C Holder Name": "A/C Holder Name",
                "Swift Code": "Swift Code",
                "Account Type": "Account Type",
                "Bank Account No": "Bank Account No",
                "Bank Account IC": "Bank Account IC",
                "Payout Company": "Payout Company",
                "MPAY": "MPAY",
                "Card Country": "Card Country",
                "Card Holder Name": "Card Holder Name",
                "Card Number": "Card Number",
                "Card Expiry Date": "Card Expiry Date",
                "Month (MM)": "Month (MM)",
                "Card Expiry Year": "Card Expiry Year",
                "Year (YYYY)": "Year (YYYY)",
                "GCC": "GCC"
            }
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "Bonus Statement",
                "statement_date": "Statement Date",
                "member_code": "Member Code",
                "name": "Name",
                "tax_number": "Tax No.",
                "highest_rank": "Highest Rank",
                "effective_rank": "Effective Rank",
                "address": "Address",
                "header_bonuses": "Bonuses",
                "gross_bonus": "Gross Bonus",
                "gross_bonus_ratio_description": "",
                "infinity_welcome_bonus": "Infinity Welcome Bonus",
                "retail_bonus": "Retail Bonus",
                "team_volume_commission": "Team Volume Commission",
                "matching_bonus": "Matching Bonus",
                "car_house_fund": "Car & House Fund",
                "incentive": "Incentive",
                "global_pool_bank": "Global Pool Bank",
                "total_gross_bonus": "Total Gross Bonus",
                "less_wht": "Less : WHT",
                "net_bonus_payable_before_bank_charges": "Net Bonus Payable (before bank charges)",
                "withdrawal_bank_charges_disclaimer": "* During commission withdrawal, %s %s remittance charges will be impose by the Company. Please take note that intermediary bank's will also charge some fees hence the actual payable amount may not match the statement amount or wallet amount.",
                "infinity_welcome_bonus_details": "Infinity Welcome Bonus Details",
                "number": "No.",
                "join_date": "Join Date",
                "type": "Type",
                "level": "Level",
                "local_amount": "Local Amount (%s)",
                "nett": "Nett",
                "tvc_details": "TVC Details",
                "batch": "Batch",
                "carry_forward": "C/Forward",
                "this_week_bv": "This Week BV",
                "this_week_ops": "This Week OPS",
                "calculation_bv": "Calculation BV",
                "tvc_point": "Point",
                "flush": "Flush",
                "carry_over": "C/Over",
                "value_per_point": "Value per Point",
                "matching_bonus_details": "Matching Bonus Details",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "Point",
                "tb_point": "TB Point",
                "iwb_nett_usd": "Nett (US$)",
                "usd": "US$"
            },
            "iwb": {
                "1p_fourth_level_onward": "1% IWB from 4th ~ ∞ level",
                "2p_second_level": "2% IWB from 2nd level",
                "2p_third_level": "2% IWB from 3rd level",
                "20p_first_level": "20% IWB from 1st level",
                "inactive_brand_ambassador": "Inactive Brand Ambassador",
                "active_brand_ambassador": "Active Brand Ambassador"
            },
            "general": {
                "paid_as_rank": "Paid as Rank",
                "active_status": "Active Status",
                "no_of_3_star_director_legs": "# of 3 Star Director Legs",
                "no_of_diamond_legs": "# of Diamond Legs",
                "left_business_volume": "Left Business Volume (BV)",
                "right_business_volume": "Right Business Volume (BV)"
            },
            "commission_and_bonuses": {
                "retail_bonus": "Retail Bonus",
                "iwb": "IWB",
                "tvc": "TVC",
                "mb": "MB",
                "other_bonuses": "Other Bonuses",
                "sub_total": "Sub-total"
            },
            "chp_gbp": {
                "total_shares": "Total Shares"
            },
            "paid_as_ranks": {
                "DRT": "Director",
                "2SDRT": "2-Star Director",
                "3SDRT": "3-Star Director",
                "DM": "Diamond",
                "2SDM": "2-Star Diamond",
                "3SDM": "3-Star Diamond",
                "PSD": "President",
                "2PSD": "2-Star President",
                "3PSD": "3-Star President",
                "CRO": "Crown",
                "2CRO": "2-Star Crown",
                "3CRO": "3-Star Crown"
            },
            "builder_ranks": {
                "builder": "Builder",
                "pro_builder": "Pro Builder",
                "elite_builder": "Elite Builder",
                "ba": "Brand Ambassador"
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "This user does not have access to locations module.",
                "resource_not_belong": "This resource not belong to you.",
                "un_authorized": "This action is not authorized",
                "email_unique": "This email already taken.",
                "not-member": "This user is not a member.",
                "invalid-account": "User account is not valid anymore"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "Inactive"
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "Outermost left downline not found.",
                "no-outer-right": "Outermost right downline not found."
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice was under sales cancellations process.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid."
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to resume enrollment.",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "Your cart is empty",
                "checkout": "Proceed to checkout",
                "cannot-checkout": "Unable to checkout",
                "cannot-checkout-epp": "Cannot checkout with EPP products and normal products combined",
                "cannot-checkout-epp-backoffice": "Unable to add {sku}. EPP products and normal products cannot be combined.",
                "delivery-stock-location-not-found": "We are unable to deliver to the specified address",
                "virel-referrer-empty": "Your session dose not have a referrer"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "ขั้นต่ำ {cv} {eligibleType} จำเป็น, โปรดปฏิบัติตามเกณฑ์ดังกล่าวเพื่อดำเนินการซื้อต่อไป",
                "minimum_cv_to_active": "เพิ่ม {cv} BV เพื่อเปิดใช้งานสำหรับ {cw}",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in iElken membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "qr": {
                "payment": {
                    "process": "Please Wait. We are processing your payment",
                    "redirect": "If you are not redirected in 5 seconds, click the button below"
                }
            },
            "payment": {
                "process": "โปรดรอ. เรากำลังดำเนินการชำระเงินของคุณ",
                "process-processed": "การชำระเงินของคุณ {status}",
                "already-processed": "การชำระเงินนี้ได้รับการดำเนินการแล้ว",
                "status-success": "ประสบความสำเร็จ",
                "status-pending": "อยู่ระหว่างการพิจารณา",
                "status-failed": "ล้มเหลว",
                "success": "สำเร็จ",
                "pending": "รอดำเนินการ",
                "failed": {
                    "header_title": "การชำระเงินล้มเหลว",
                    "webview_body_text": "การชำระเงินตามคำสั่งซื้อของคุณล้มเหลว คุณสามารถคลิกปุ่มต่อไปนี้เพื่อกลับไปที่ใบสั่งขาย",
                    "non_webview_body_text": "การชำระเงินตามคำสั่งซื้อของคุณล้มเหลว",
                    "return_button_title": "กลับ"
                },
                "msg-success": "ขอบคุณ",
                "msg-pending": "การชำระเงินของคุณอยู่ระหว่างดำเนินการเราจะแจ้งให้คุณทราบเมื่อเสร็จสิ้น",
                "msg-failed": "กรุณาลองอีกครั้ง",
                "status-successful": "ประสบความสำเร็จ",
                "redirect": "หากคุณไม่ถูกเปลี่ยนการเลือกใน 5 วินาทีให้คลิกปุ่มด้านล่าง",
                "continue": "ดำเนินการต่อ",
                "empty": "เกิดปัญหา !!! โปรดติดต่อทีมสนับสนุนเพื่อสอบถาม",
                "sale-completed": "การขายนี้ได้รับการชำระเงินเต็มจำนวนแล้ว",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "การชำระเงินสำเร็จ",
                    "webview_body_text": "ขอบคุณสำหรับการชำระเงิน จากนั้นคุณสามารถคลิกที่ปุ่มต่อไปนี้เพื่อดำเนินการสั่งซื้อให้เสร็จสมบูรณ์",
                    "webview_complete_payment_button_title": "ชำระเงินเสร็จสมบูรณ์",
                    "non_webview_body_text": "ขอบคุณสำหรับการชำระเงิน หลังจากนี้คุณสามารถแจ้งบุคคลที่ส่งลิงก์การชำระเงินให้คุณเพื่อยืนยันสถานะการสั่งซื้อ",
                    "non_webview_share_button_title": "แบ่งปัน",
                    "non_webview_with_callback_body_text": "ขอบคุณสำหรับการชำระเงิน จากนั้นคุณสามารถคลิกปุ่มต่อไปนี้เพื่อกลับไปที่หน้าสถานะคำสั่งซื้อ",
                    "non_webview_with_callback_button_title": "กลับ",
                    "sharer_title": "Elken Global",
                    "sharer_description": "ฉันชำระเงินเรียบร้อยแล้ว: currency_iso_code: total_payment_amount โดยใช้: payment_provider_name สำหรับหมายเลขใบสั่งขาย: sale_document_number"
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you chosen is not eligible for the selected enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation code to activate you saliva collection kit online."
                },
                "sms": "Your TrueYou activation code is {code}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    },
    "tw": {
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_malaysia_us_only": "{report} report is only available for Malaysia and USA",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item"
            }
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "bonus_statement": {
                "header_title": "獎金報表",
                "statement_date": "報表日期",
                "member_code": "會員編號",
                "name": "會員姓名",
                "tax_number": "統一編號",
                "highest_rank": "最高位階",
                "effective_rank": "支付位階",
                "address": "地址",
                "header_bonuses": "獎金項目",
                "gross_bonus": "總獎金",
                "gross_bonus_ratio_description": "每年愛康全球公佈獎金固定匯率：2022匯率",
                "infinity_welcome_bonus": "快速啟動獎金",
                "retail_bonus": "零售獎金",
                "team_volume_commission": "團隊獎金",
                "matching_bonus": "對等獎金",
                "car_house_fund": "超級跑車 & 豪華房產獎勵",
                "incentive": "額外獎勵活動",
                "global_pool_bank": "全球年度分紅獎金",
                "total_gross_bonus": "獎金項目",
                "less_wht": "減：WHT",
                "net_bonus_payable_before_bank_charges": "應付淨獎金",
                "withdrawal_bank_charges_disclaimer": "在獎金提取期間，本公司將收取 %s %s 匯款費用。請注意，中轉銀行也會收取一些費用，因此實際應付金額可能與結單金額或錢包金額不符。",
                "infinity_welcome_bonus_details": "快速啟動獎金明細",
                "number": "編號",
                "join_date": "加入日期",
                "type": "類型",
                "level": "推薦代數",
                "local_amount": "獎金 (%s$)",
                "nett": "獎金 (美金$)",
                "tvc_details": "團隊獎金明細",
                "batch": "獎金週",
                "carry_forward": "移轉分數",
                "this_week_bv": "本獎金週新增BV",
                "this_week_ops": "本週OPS",
                "calculation_bv": "計算獎金BV分數",
                "tvc_point": "團隊獎金(TVC)",
                "flush": "移轉保留BV分數",
                "carry_over": "移轉BV分數",
                "value_per_point": "積分比值",
                "matching_bonus_details": "對等獎金明細",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "對等獎金",
                "tb_point": "團隊獎金",
                "iwb_nett_usd": "總獎金 (美金)",
                "usd": "美金"
            }
        }
    },
    "zh-Hans-CN": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "exception": "Sorry we are unable to process your request, please try again!",
            "reset-password": {
                "sms": "茲收到您要求重设iBS登入密码的通知。您的验证码(OTP)為{otp}。此验证码{validity}分钟后失效。",
                "email": "\n            亲爱的 {name}, \n            <br><br>\n        \n            茲收到您要求重设iBS登入密码的通知。您的验证码(OTP)為{otp}。\n            <br>\n            此验证码{validity}分钟后失效。\n            <br><br>\n            {url}\n            如果您不想重设密码，请忽略或删除这封邮件。\n            <br><br>\n            顺祝 商祺!!\n            <br><br>\n            \n            支援团队\n            <br><br>\n            <hr>\n            <br><br>\n            网址 : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            电子邮件 : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - 这是系统自动讯息，请不用回复。 - - - ></div>\n        "
            },
            "reset-security-pin-sent": "We have e-mailed you security pin reset instructions!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS EWallet security pin.  \n            <br>\n            Please login to your member portal follow the steps below:\n            <br>\n            1. Go to <b>My Account</b>.\n            <br>\n            2. Click on <b>e-Wallet Settings</b> tab.\n            <br>\n            3. Click on <b>Reset</b> button and follow through the step by step process.\n            <br><br>\n            If you do not want to reset your security pin, you may simply ignore or delete this email; your security pin will not be changed, and you will still be able to access your e-wallet.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-attempt-max": "You’ve reached the maximum attempt. Please try again later.",
            "reset-attempt-gap": "You are resetting the password too often. Please try again later.",
            "reset-attempt-expire": "You’ve reached the maximum attempt. OTP is invalid/expired"
        },
        "resume_payment": {
            "email": {
                "subject": "Your order {document_number} is waiting for you"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            },
            "itoken": {
                "campaign_overlap": "Unable to create a new campaign when another campaign is active",
                "invalid_item": "The item provided is not a valid product or kitting",
                "dummy_item": "A dummy product or kitting is not allowed to be used as token entitlement item",
                "rental_item": "Rental product or kitting is not allowed to be used as token entitlement item"
            }
        },
        "email": {
            "welcome": {
                "subject": "Welcome to Elken IBS",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for registering on our IBS system and we welcome you onboard",
                "visit": "Visit IBS",
                "footer": "Thank you for using our Elken IBS!"
            },
            "staff_welcome": {
                "subject": "Welcome to Elken",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for being part of Elken. and welcome on board.",
                "credentials": "please use the following credentials to login in to our IBS.",
                "email": "Email: {email}",
                "password": "Password: {password}",
                "visit": "Visit IBS",
                "footer": "Elken IBS!"
            }
        },
        "enrollment": {
            "email": {
                "subject": "欢迎加入爱康",
                "content": "\n            亲爱的 {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">欢迎加入爱康</span>\n            <br><br>\n            \n            恭喜您为迈向将来拥有财富及成功的第一步, 此乃最佳良机加入我们的行列。 \n            <br><br>\n            Elken Global奖金计划的设计让您可永续发展及赚取丰厚回报，为您提供一个稳固及盈 利的业务良机。 \n            <br><br>\n            我们建议您多些了解Elken Global奖金计划、 业务工具、管理层和产品知识，有助您建 立一个成功的企业。作为会员，您有权以会员价格购买我们的产品。 \n            <br><br>\n            再次感谢您英明的决定成为我们的伙伴。 \n            <br><br>\n            顺祝 商祺! \n            <br>\n            管理团队 \n            <br><br>\n            网址: <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            电子邮件: <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><hr>            \n            您的登入资料<br>\n            ID/会员号码: {iboMemberId}<br><br>登入密码: {password}<br><br>*您可以透过登入网站更改您的密码.\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - 这是系统自动讯息，请不用回复。 - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "欢迎加入爱康，请登入iBS: {url} 您的IBO ID: {iboMemberId} 密码: {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "duplicated_enrollment_error": "Failure to complete enrolment due to the provided contact details already exist in our database. Please contact CS."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "countries_dynamic_content": {
            "address": {
                "Permanent": "Permanent",
                "Correspondence": "Correspondence",
                "Shipping 1": "Shipping 1",
                "Shipping 2": "Shipping 1",
                "Address 1": "Address 1",
                "Address 2": "Address 2",
                "Address 3": "Address 3",
                "Address 4": "Address 4",
                "postcode": "Postcode",
                "Postcode": "Postcode",
                "state": "State",
                "State": "State",
                "city": "City",
                "City": "City",
                "country": "Country",
                "Country": "Country"
            },
            "member_payout_options": {
                "BANK": "BANK",
                "Bank Country": "Bank Country",
                "Bank Name": "Bank Name",
                "A/C Holder Name": "A/C Holder Name",
                "Swift Code": "Swift Code",
                "Account Type": "Account Type",
                "Bank Account No": "Bank Account No",
                "Bank Account IC": "Bank Account IC",
                "Payout Company": "Payout Company",
                "MPAY": "MPAY",
                "Card Country": "Card Country",
                "Card Holder Name": "Card Holder Name",
                "Card Number": "Card Number",
                "Card Expiry Date": "Card Expiry Date",
                "Month (MM)": "Month (MM)",
                "Card Expiry Year": "Card Expiry Year",
                "Year (YYYY)": "Year (YYYY)",
                "GCC": "GCC"
            }
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "iwb": {
                "1p_fourth_level_onward": "无限启动奖金1%从第四层到无限层",
                "2p_second_level": "无限启动奖金2%从第二层",
                "2p_third_level": "无限启动奖金2%从第三层",
                "20p_first_level": "无限启动奖金20%从第一层",
                "inactive_brand_ambassador": "不活跃品牌大使",
                "active_brand_ambassador": "活跃品牌大使"
            },
            "general": {
                "paid_as_rank": "受付位阶",
                "active_status": "活跃状态",
                "no_of_3_star_director_legs": "# 3星总监线",
                "no_of_diamond_legs": "# 钻石线",
                "left_business_volume": "左销售业绩(BV)",
                "right_business_volume": "右销售业绩(BV)"
            },
            "commission_and_bonuses": {
                "retail_bonus": "零售奖金",
                "iwb": "无限启动奖金",
                "tvc": "团队奖金",
                "mb": "对等奖金",
                "other_bonuses": "其他奖金",
                "sub_total": "总计"
            },
            "chp_gbp": {
                "total_shares": "总股份"
            },
            "paid_as_ranks": {
                "DRT": "总监",
                "2SDRT": "2星总监",
                "3SDRT": "3星总监",
                "DM": "钻石",
                "2SDM": "2星钻石",
                "3SDM": "3星钻石",
                "PSD": "总裁",
                "2PSD": "2星总裁",
                "3PSD": "3星总裁",
                "CRO": "皇冠",
                "2CRO": "2星皇冠",
                "3CRO": "3星皇冠"
            },
            "builder_ranks": {
                "builder": "营造商",
                "pro_builder": "专业营造商",
                "elite_builder": "精英营造商",
                "ba": "品牌大使"
            },
            "bonus_statement": {
                "header_title": "奖金明细表",
                "statement_date": "明细表日期",
                "member_code": "会员编号",
                "name": "会员姓名",
                "tax_number": "统一编号",
                "highest_rank": "最高位阶",
                "effective_rank": "支付位阶",
                "address": "地址",
                "header_bonuses": "奖金项目",
                "gross_bonus": "总奖金",
                "gross_bonus_ratio_description": "每年爱康全球展览固定价格：2022汇率",
                "infinity_welcome_bonus": "快速启动奖金",
                "retail_bonus": "零售奖金",
                "team_volume_commission": "团队奖金",
                "matching_bonus": "对等奖金",
                "car_house_fund": "超级跑车 & 豪华房产奖励",
                "incentive": "额外奖励活动",
                "global_pool_bank": "全球年度分红奖金",
                "total_gross_bonus": "总奖金",
                "less_wht": "減：WHT",
                "net_bonus_payable_before_bank_charges": "应付奖金净额",
                "withdrawal_bank_charges_disclaimer": "* 在佣金提取期间，本公司将收取 %s %s 汇款费用。请注意，中转银行也会收取一些费用，因此实际应付金额可能与结单金额或钱包金额不符。",
                "infinity_welcome_bonus_details": "快速启动奖金明细",
                "number": "编号",
                "join_date": "加入日期",
                "type": "类型",
                "level": "推荐代数",
                "local_amount": "奖金 (%s$)",
                "nett": "奖金 (美金$)",
                "tvc_details": "团队奖金明细",
                "batch": "奖金周",
                "carry_forward": "移转分数",
                "this_week_bv": "本奖金周新增BV",
                "this_week_ops": "本周OPS",
                "calculation_bv": "计算奖金BV分数",
                "tvc_point": "团队奖金(TVC)",
                "flush": "移转保留BV分数",
                "carry_over": "移转BV分数",
                "value_per_point": "积分比值",
                "matching_bonus_details": "对等奖金明细",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "对等奖金",
                "tb_point": "团队奖金",
                "iwb_nett_usd": "总奖金 (美金)",
                "usd": "美金"
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "This user does not have access to locations module.",
                "resource_not_belong": "This resource not belong to you.",
                "un_authorized": "This action is not authorized",
                "email_unique": "This email already taken.",
                "not-member": "This user is not a member.",
                "invalid-account": "User account is not valid anymore"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "不活跃"
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "最外左下线悬空。",
                "no-outer-right": "最外右下线悬空。"
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice was under sales cancellations process.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid."
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-member-type": "This member type is not allowed to make payment via e-wallet.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to resume enrollment.",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "您的购物车是空的",
                "checkout": "进行结账",
                "cannot-checkout": "无法结帐",
                "cannot-checkout-epp": "无法将EPP产品和普通产品合并结帐",
                "cannot-checkout-epp-backoffice": "无法添加{sku}。 EPP产品和普通产品不能结合使用。",
                "delivery-stock-location-not-found": "我们无法送达指定地址",
                "virel-referrer-empty": "您的环节没有推荐人"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "请确保您在购买前已达 {cv} {eligibleType} 的最低AMP额度",
                "minimum_cv_to_active": "添加 {cv} BV 以激活 {cw}",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in Elken Global membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "payment": {
                "process": "请稍候。 我们正在处理您的款项",
                "process-processed": "您的付款{status}",
                "already-processed": "此付款已处理",
                "status-success": "已成功",
                "status-pending": "等待中",
                "status-failed": "失败了",
                "success": "成功",
                "pending": "待定",
                "failed": {
                    "header_title": "付款失败",
                    "webview_body_text": "您的订单付款失败。 您可以点击以下按钮返回销售订单。",
                    "non_webview_body_text": "您的订单付款失败。",
                    "return_button_title": "返回"
                },
                "msg-success": "謝謝",
                "msg-pending": "您的付款尚待处理，完成后我们会通知您",
                "msg-failed": "请再试一次",
                "status-successful": "已成功",
                "redirect": "如果5秒钟内您没有被重定向，请点击下面的按钮",
                "continue": "继续",
                "empty": "发生问题！！！请联系支援团队以进行咨询",
                "sale-completed": "这笔订单已付清。",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "付款成功",
                    "webview_body_text": "谢谢您的付款。 接下来，您可以点击以下按钮以完成订购。",
                    "webview_complete_payment_button_title": "完成付款",
                    "non_webview_body_text": "谢谢您的付款。 接下来，您可以联系发送付款链接给您的人以确认订单状态。",
                    "non_webview_share_button_title": "分享",
                    "non_webview_with_callback_body_text": "谢谢您的付款。 接下来，您可以点击以下按钮返回到订单状态页面。",
                    "non_webview_with_callback_button_title": "返回",
                    "sharer_title": "爱康环球",
                    "sharer_description": "我已经成功使用{payment_provider_name} 付款{currency_iso_code}{total_payment_amount}于订{sale_document_number}。"
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you choose is not eligible for the enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation code to activate you saliva collection kit online."
                },
                "sms": "Your TrueYou activation code is {code}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    },
    "zh-Hant-HK": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "exception": "Sorry we are unable to process your request, please try again!",
            "reset-password": {
                "sms": "To reset the password for your iBS account, please enter the OTP {otp}, expires {validity} min. {url}",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS login password.  \n            <br>\n            Please enter the one-time password (OTP) : {otp} \n            <br>\n            The OTP only valid for {validity} minutes.  \n            <br><br>\n            {url}\n            If you do not want to reset your password, you may simply ignore or delete this email; your login password will not be changed, and you will still be able to access your member portal.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-security-pin-sent": "We have e-mailed you security pin reset instructions!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            Dear {name}, \n            <br><br>\n        \n            We have received notification that you want to reset your iBS EWallet security pin.  \n            <br>\n            Please login to your member portal follow the steps below:\n            <br>\n            1. Go to <b>My Account</b>.\n            <br>\n            2. Click on <b>e-Wallet Settings</b> tab.\n            <br>\n            3. Click on <b>Reset</b> button and follow through the step by step process.\n            <br><br>\n            If you do not want to reset your security pin, you may simply ignore or delete this email; your security pin will not be changed, and you will still be able to access your e-wallet.  \n            <br><br>\n            To Your Success! \n            <br><br>\n            \n            Support Team \n            <br><br>\n            <hr>\n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "reset-attempt-max": "You’ve reached the maximum attempt. Please try again later.",
            "reset-attempt-gap": "You are resetting the password too often. Please try again later.",
            "reset-attempt-expire": "You’ve reached the maximum attempt. OTP is invalid/expired"
        },
        "resume_payment": {
            "email": {
                "subject": "Your order {document_number} is waiting for you"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            }
        },
        "email": {
            "welcome": {
                "subject": "Welcome to Elken IBS",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for registering on our IBS system and we welcome you onboard",
                "visit": "Visit IBS",
                "footer": "Thank you for using our Elken IBS!"
            },
            "staff_welcome": {
                "subject": "Welcome to Elken",
                "dear": "Dear {Salutation} {Name} ",
                "body": "Thank you for being part of Elken. and welcome on board.",
                "credentials": "please use the following credentials to login in to our IBS.",
                "email": "Email: {email}",
                "password": "Password: {password}",
                "visit": "Visit IBS",
                "footer": "Elken IBS!"
            }
        },
        "enrollment": {
            "email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Welcome to Elken </span>\n            <br><br>\n            \n            Congratulations on taking your first step with us to secure your future and personal financial success. It is the right time and you have made a fantastic choice to be part of us. \n            <br><br>\n            The Elken Global Compensation Plan is designed to be rewarding and sustainable to ensure you have a strong and profitable business. \n            <br><br>\n            We encourage you to take the time to familiarize yourself with the Elken Global Compensation Plan, business tool/management and products to help you build a successful business. As a member, you are entitled to purchase our products at member price. \n            <br><br>\n            Once again, thank you for making the right decision to <span style=\"color: red\">join us</span> . \n            <br><br>\n            To Your Success! \n            <br>\n            The Management Team \n            <br>\n            Email: customerservice@elken.com \n            <br><hr>            \n            Your Login Info<br>\n            Member ID: {iboMemberId}<br><br>Current Password: {password}<br><br>*You can change your password by logging into member portal.\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "Welcome to Elken Global and congratulations on your enrollment! Please log into your iBS: {url} with IBO ID: {iboMemberId} Password: {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "duplicated_enrollment_error": "Failure to complete enrolment due to the provided contact details already exist in our database. Please contact CS."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "notification": {
            "types": {
                "payment": "Payment",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "iwb": {
                "1p_fourth_level_onward": "無限啟動獎金1%從第四層到無限層",
                "2p_second_level": "無限啟動獎金2%從第二層",
                "2p_third_level": "無限啟動獎金2%從第三層",
                "20p_first_level": "無限啟動獎金20%從第一層",
                "inactive_brand_ambassador": "不活躍品牌大使",
                "active_brand_ambassador": "活躍品牌大使"
            },
            "general": {
                "paid_as_rank": "受付等級",
                "active_status": "活躍狀態",
                "no_of_3_star_director_legs": "# 3星總監線",
                "no_of_diamond_legs": "# 鑽石線",
                "left_business_volume": "左銷售業績(BV)",
                "right_business_volume": "右銷售業績(BV)"
            },
            "commission_and_bonuses": {
                "retail_bonus": "零售獎金",
                "iwb": "無限啟動獎金",
                "tvc": "團隊獎金",
                "mb": "對等獎金",
                "other_bonuses": "其他獎金",
                "sub_total": "總計"
            },
            "chp_gbp": {
                "total_shares": "總股份"
            },
            "paid_as_ranks": {
                "DRT": "總裁",
                "2SDRT": "2星總裁",
                "3SDRT": "3星總裁",
                "DM": "鑽石",
                "2SDM": "2星鑽石",
                "3SDM": "3星鑽石",
                "PSD": "總裁",
                "2PSD": "2星總裁",
                "3PSD": "3星總裁",
                "CRO": "皇冠",
                "2CRO": "2星皇冠",
                "3CRO": "3星皇冠"
            },
            "builder_ranks": {
                "builder": "營造商",
                "pro_builder": "專業營造商",
                "elite_builder": "精英營造商",
                "ba": "品牌大使"
            },
            "bonus_statement": {
                "header_title": "獎金明細表",
                "statement_date": "明細表日期",
                "member_code": "會員編號",
                "name": "會員姓名",
                "tax_number": "統一編號",
                "highest_rank": "最高位階",
                "effective_rank": "支付位階",
                "address": "地址",
                "header_bonuses": "獎金項目",
                "gross_bonus": "總獎金",
                "gross_bonus_ratio_description": "每年愛康全球公佈獎金固定匯率：2022匯率",
                "infinity_welcome_bonus": "快速啟動獎金",
                "retail_bonus": "零售獎金",
                "team_volume_commission": "團隊獎金",
                "matching_bonus": "對等獎金",
                "car_house_fund": "超級跑車 & 豪華房產獎勵",
                "incentive": "額外獎勵活動",
                "global_pool_bank": "全球年度分紅獎金",
                "total_gross_bonus": "總獎金",
                "less_wht": "減：WHT",
                "net_bonus_payable_before_bank_charges": "應付獎金淨額",
                "withdrawal_bank_charges_disclaimer": "* 在佣金提取期間，本公司將收取 %s %s 匯款費用。請注意，中轉銀行也會收取一些費用，因此實際應付金額可能與結單金額或錢包金額不符。",
                "infinity_welcome_bonus_details": "快速啟動獎金明細",
                "number": "編號",
                "join_date": "加入日期",
                "type": "類型",
                "level": "推薦代數",
                "local_amount": "獎金 (%s$)",
                "nett": "獎金 (美金$)",
                "tvc_details": "團隊獎金明細",
                "batch": "奖金週",
                "carry_forward": "移轉分數",
                "this_week_bv": "本獎金周新增BV",
                "this_week_ops": "本週OPS",
                "calculation_bv": "計算獎金BV分數",
                "tvc_point": "團隊獎金(TVC)",
                "flush": "移轉保留BV分數",
                "carry_over": "移轉BV分數",
                "value_per_point": "積分比值",
                "matching_bonus_details": "對等獎金明細",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "對等獎金",
                "tb_point": "團隊獎金",
                "iwb_nett_usd": "總獎金 (美金)",
                "usd": "美金"
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "This user does not have access to locations module.",
                "resource_not_belong": "This resource not belong to you.",
                "un_authorized": "This action is not authorized",
                "email_unique": "This email already taken.",
                "not-member": "This user is not a member.",
                "invalid-account": "User account is not valid anymore"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "不活躍"
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "最外左下綫懸空。",
                "no-outer-right": "最外右下綫懸空。"
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice was under sales cancellations process.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid."
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to resume enrollment.",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "您的購物車是空的",
                "checkout": "進行結賬",
                "cannot-checkout": "無法結帳",
                "cannot-checkout-epp": "無法將EPP產品和普通產品合併結賬",
                "cannot-checkout-epp-backoffice": "無法添加{sku}。 EPP產品和普通產品不能結合使用。",
                "delivery-stock-location-not-found": "我們無法送達指定地址",
                "virel-referrer-empty": "您的環節沒有推薦人"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "请确保您在购买前已达 {cv} {eligibleType} 的最低AMP额度",
                "minimum_cv_to_active": "添加 {cv} BV 以激活 {cw}",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in Elken Global membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "payment": {
                "process": "請稍候。我們正在處理您的款項",
                "process-processed": "您的付款{status}",
                "already-processed": "此付款已處理",
                "status-success": "已成功",
                "status-pending": "等待中",
                "status-failed": "失敗了",
                "success": "成功",
                "pending": "待定",
                "failed": {
                    "header_title": "付款失敗",
                    "webview_body_text": "您的訂單付款失敗。您可以點擊以下按鈕返回銷售訂單。",
                    "non_webview_body_text": "您的訂單付款失敗",
                    "return_button_title": "返回"
                },
                "msg-success": "謝謝",
                "msg-pending": "您的付款尚待處理，完成後我們會通知您",
                "msg-failed": "請再試一次",
                "status-successful": "已成功",
                "redirect": "如果5秒鐘內您沒有被重定向，請點擊下面的按鈕",
                "continue": "繼續",
                "empty": "發生問題！ ！ ！請聯絡支援團隊以進行諮詢",
                "sale-completed": "這筆訂單已付清。",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "付款成功",
                    "webview_body_text": "謝謝您的付款。接下來，您可以點擊以下按鈕以完成訂購。",
                    "webview_complete_payment_button_title": "完成付款",
                    "non_webview_body_text": "謝謝您的付款。接下來，您可以聯絡發送付款鏈接給您的人以確認訂單狀態。",
                    "non_webview_share_button_title": "分享",
                    "non_webview_with_callback_body_text": "謝謝您的付款。接下來，您可以點擊以下按鈕返回到訂單狀態頁面。",
                    "non_webview_with_callback_button_title": "返回",
                    "sharer_title": "Elken Global",
                    "sharer_description": "我已經成功使用{payment_provider_name}付款{currency_iso_code}{total_payment_amount}於訂單{sale_document_number}。"
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you choose is not eligible for the enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation code to activate you saliva collection kit online."
                },
                "sms": "Your TrueYou activation code is {code}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    },
    "zh-Hant-TW": {
        "auth": {
            "failed": "這些憑據與我們的記錄不相符。",
            "throttle": "嘗試登入的次數過多。請在{seconds}秒後重試。"
        },
        "passwords": {
            "password": "密碼必須至少包含六個字符，並且與確認字符匹配。",
            "reset": "您的密碼已重設！",
            "sent": "密碼重設鏈接已發送至您的電郵！",
            "token": "密碼重設Token無效。",
            "user": "我們找不到使用該電郵件的用戶。",
            "exception": "抱歉，我們無法處理您的請求，請重試！",
            "reset-password": {
                "sms": "茲收到您要求重設iBS登入密碼的通知。您的驗證碼(OTP)為{otp}。此驗證碼{validity}分鐘后失效。",
                "email": "\n            親愛的 {name}, \n            <br><br>\n        \n            茲收到您要求重設iBS登入密碼的通知。您的驗證碼(OTP)為{otp}。 \n            <br>\n            此驗證碼{validity}分鐘后失效。\n            <br><br>\n            {url}\n            如果不能連接上面的連結，請複製並貼上到您的瀏覽器。\n            <br><br>\n            如果您不想重設密碼，請忽略或刪除這封郵件。\n            <br><br>\n            順祝 商祺!! \n            <br><br>\n            \n            支援團隊 \n            <br><br>\n            <hr>\n            <br><br>\n            網址 : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            電子郵件 : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - 這是系統自動訊息，請不要回復 - - - ></div>\n        "
            },
            "reset-security-pin-sent": "安全密碼重設說明已通過電郵發送給您!",
            "reset-security-pin": {
                "sms": "To reset the security pin for your iBS account EWallet, please login to your member portal and go to \"My Account >> e-Wallet Settings\" and click \"Reset\" button.",
                "email": "\n            致 {name}, \n            <br><br>\n        \n            我們收到您想重設iBS 電子錢包安全密碼的通知。\n            <br>\n            請按照以下步驟登入您的會員戶口：\n            <br>\n            1. 進入<b>我的帳戶</b>。\n            <br>\n            2. 點擊<b>電子錢包設置</b>標籤。\n            <br>\n            3. 點擊<b>重設</b>按鈕，並按照步驟進行操作。\n            <br><br>\n           如果您不想重設密碼，可以直接忽略或刪除此郵件，您的登入密碼將不會被更改，並仍可以登入您的電子錢包。\n           <br><br>\n            祝您成功!\n            <br><br>\n            \n            技術團隊 啟\n            <br><br>\n            <hr>\n            <br><br>\n            網站 ： <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            電子郵件 : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - 此消息是自動生成的。請不要回覆。 - - - ></div>\n        "
            },
            "reset-attempt-max": "您已達到嘗試次數上限。請稍後再試。",
            "reset-attempt-gap": "您重置密碼過於頻繁。請稍後再試。",
            "reset-attempt-expire": "一次性密碼(OTP)無效，因為達到了重設密碼的嘗試次數。請再次請求重設密碼"
        },
        "resume_payment": {
            "email": {
                "subject": "您的訂單 {document_number} 正在等待您。"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "icPassport": "The {attribute} must has value of (IC or Passport) only.",
            "bonus_summary_not_found": "The user {user} does not have a report on commission week {cw}",
            "yearly_income_not_found": "The user {user} does not have a yearly income report for year {year}",
            "yearly_income_report_countries_only": "{report} report is only available for {countries}",
            "eWallet_check": "Selected IBO User's e-Wallet is inactive/blocked",
            "eWallet_recipient_check": "Your recipient's e-Wallet is inactive/blocked",
            "eWallet_amount_regex": "Amount is not in proper currency format",
            "security_pin_check": "The {attribute} is invalid.",
            "security_pin_value": "This field can only contain numeric value",
            "user_otp_check": "The {attribute} is invalid/expired.",
            "giro_exists": "GIRO Bank Payment Record already exists.",
            "giro_in_progress": "This GIRO Bank Payment Record still in progress.",
            "balance_check": "Insufficient funds",
            "country_giro_types_exists": "GIRO types for selected Country does not exist.",
            "password_check": "Your {attribute} is incorrect.",
            "sale_product_does_not_belongs_to_sale": "The {attribute} does not belong to selected sale number",
            "member_email_validated": "Your email has already been verified.",
            "to_cw_gte": "CW To must be greater than CW From",
            "evoucher_redemption_check": "The {attribute} is invalid.",
            "evoucher_sale_check": "The sale status is not completed for following eVouchers. {evouchers}",
            "selected_quantity_check": "Redemption selection quantity is not accurate for {name} - {code}",
            "member_subscription_unauthorized": "Membership Subscription not allowed for selected member.",
            "bonus_summary_finalized": "This record cannot be updated for given CW as Bonus has been finalized.",
            "bonus_summary_not_finalized": "This action cannot be performed for given CW as Bonus is not yet finalized.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "mobile_1_num": {
                    "unique_with": "The mobile number entered is already registered with another Member account. Please enter a new mobile number."
                },
                "member_data.contact_info.email": {
                    "required_if": "The {attribute} field is required if the preferred contact is Email"
                },
                "member_data.contact_info.mobile_1_country_code_id": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone"
                },
                "member_data.contact_info.mobile_1_num": {
                    "required_if": "The {attribute} field is required if the preferred contact is Phone",
                    "regex": "The {attribute} field is an invalid number"
                },
                "verification_mobile": {
                    "regex": "The {attribute} field is an invalid number"
                }
            },
            "attributes": {
                "otp": "OTP",
                "member_data.contact_info.email": "email",
                "member_data.contact_info.mobile_1_country_code_id": "mobile country id",
                "member_data.contact_info.mobile_1_num": "Mobile Number"
            },
            "purchase_limit": {
                "exceeded": "Your purchase amount have exceeded the limit of {value} {currency}.",
                "not_reached": "Your purchase amount have not reached the minimum of {value} {currency}."
            }
        },
        "email": {
            "welcome": {
                "subject": "歡迎來到愛康 IBS",
                "dear": "尊貴的 {Salutation} {Name} ",
                "body": "感謝您在我們的IBS系統上進行註冊，我們歡迎您的加入",
                "visit": "登入IBS",
                "footer": "感謝您使用愛康 IBS！"
            },
            "staff_welcome": {
                "subject": "歡迎加入愛康",
                "dear": "尊貴的 {Salutation} {Name} ",
                "body": "感謝您加入愛康， 歡迎成為我們的一份子。",
                "credentials": "請使用以下證件登入我們的IBS。",
                "email": "電子郵件: {email}",
                "password": "密碼： {password}",
                "visit": "登入IBS",
                "footer": "愛康IBS！"
            }
        },
        "enrollment": {
            "email": {
                "subject": "歡迎加入愛康",
                "content": "\n            親愛的 {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">歡迎加入愛康</span>\n            <br><br>\n            \n            恭喜您為邁向將來擁有財富及成功的第一步, 此乃最佳良機加入我們的行列。 \n            <br><br>\n            Elken Global 獎金計劃的設計讓您可永續發展及賺取豐厚回報，為您提供一個穩固及盈利 的業務良機。 \n            <br><br>\n            我們建議您多些瞭解Elken Global獎金計劃、 業務工具、管理層和產品知識，有助您建立一個成功的企業。作為會員，您有權以會員價格購買我們的產品。 \n            <br><br>\n            再次感謝您英明的決定成為我們的夥伴。 \n            <br><br>\n            順祝 商祺! \n            <br>\n            管理團隊 \n            <br><br>\n            網址: <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            電子郵件: <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br><hr>            \n            您的登入資料<br>\n            ID/會員號碼: {iboMemberId}<br><br>登入密碼: {password}<br><br>*您可以透過登入網站更改您的密碼\n            <a href=\"{url}\">{url}</a>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - 這是系統自動訊息，請不用回复 - - - ></div>\n        "
            },
            "pfc_email": {
                "subject": "Welcome to Elken",
                "content": "\n            Dear {name}, \n            <br><br>\n        \n            <span style=\"color: blue\">Thank you for your interest with Elken.</span>\n            <br><br>\n                        \n            If you have purchased an Elken product, it will be delivered within 3-7 working days.\n            <br><br>\n            \n            You are now entitled to purchase our products at member price.  \n            <br><br>\n            Selected as one of the top 50 direct-selling companies in the world, Elken offers high-tech, personalised and innovative products. \n            <br><br>\n            Elken also aims to provide you with excellent reward opportunities. Through our well-researched business plans and training, you can start your business with peace of mind and increase your income to reach your personal goals and, at the same time, creating the dream life for you and your family.\n            <br><br>\n            We look forward to building you to build others! \n            <br><br>\n            Cheers to Your Success! \n            <br>\n            The Management Team \n            <br><br>\n            Web : <a href=\"www.elkenglobal.com\">www.elkenglobal.com</a>\n            <br>\n            Email : <a href=\"mailto:customerservice@elken.com\">customerservice@elken.com</a>\n            <br>\n            Hotline : 03-80210088\n            <br><hr>            \n            This is an automated email. Your member ID (below) is generated by the email. You will require a password to access our e-Shop.\n            \n            Member ID: {iboMemberId}\n            <br><br>\n            Please contact our customer service to activate your access for our Elken e-Shop.\n            <br><br>\n            You can change your password by logging into our Elken member portal. <a href=\"{url}\">{url}</a>\n        "
            },
            "sms": {
                "content": "歡迎加入愛康，請登入iBS: {url} 您的IBO ID: {iboMemberId} 密碼 : {password}"
            },
            "pfc_sms": {
                "content": "Welcome to Elken. Login to your iBS: {url} with IBO ID: {iboMemberId} & engage with CS on LiveChat to activate your access."
            },
            "taiwan_enrollment_form": "\n        親愛的 {name} 您好，<br>\n        歡迎加入愛康台灣。恭喜您完成系統註冊開啟事業第一步！透過愛康高品質產品和系統訓練，愛康將逐步帶領您邁向優質的生活。感謝您與愛康攜手同行，與我們共創美好未來！最後，小小提醒，成為會員需提供底下連結的書面資料，若已繳交，則請忽略此訊息。<br>\n        <br><br>\n        <a href=\"https://bit.ly/twnmg\">新人入會文件</a>\n        <br><br>\n        <a href=\"{link}\">點擊此處</a> 列印愛康入會申請表格及合約條款書。<br>\n        如果您有任何疑問請撥打愛康台灣免付費客服電話：0800-880-689<br>\n        管理團隊謝謝您<br><br>\n        網址: www.elkenglobal.com<br>\n        電子郵件: customerservice@elken.com<br>\n        \n        &lt; - - - 這是系統自動訊息，請不用回复- - - &gt;\n    ",
            "taiwan_enrollment_sms": {
                "content": "親愛的 {name} 您好, 歡迎加入愛康台灣。恭喜您完成系統註冊開啟事業第一步！透過愛康高品質產品和系統訓練，愛康將逐步帶領您邁向優質的生活。感謝您與愛康攜手同行，與我們共創美好未來！最後，小小提醒，成為會員需提供底下連結的書面資料，若已繳交，則請忽略此訊息。 新人入會文件 https://bit.ly/twnmg 點擊此處列印愛康入會申請表格及合約條款書。 {link} 免費客服電話：0800-880-689， 管理團隊謝謝您 www.elkenglobal.com"
            },
            "email_temp": {
                "subject": "愛康註冊恢復ID",
                "content": "\n        親愛的 {name} \n        <br>\n        歡迎來到Elken Global，感謝您開始進行註冊！\n        <br>\n        您的愛康註冊專屬ID：{unique_id}.\n        <br>\n        請保留此ID以便恢復註冊備用。"
            },
            "duplicated_enrollment_error": "註冊無效因為您所提供的聯絡資料已存在於數據庫中。請與客服聯女。."
        },
        "pagination": {
            "previous": "＆laquo; 之前",
            "next": "下一個 ＆raquo;"
        },
        "notification": {
            "types": {
                "payment": "付款",
                "bundle": "Bundle"
            },
            "payment": {
                "payment_complete": {
                    "text": "Your {payment_mode} payment of {amount} for {document_number} has been completed",
                    "links": {
                        "ios": "/sales/{sale_id}",
                        "android": "/sales/{sale_id}",
                        "eshop": "/sales/{sale_id}"
                    }
                }
            },
            "bundle": {
                "require_attention": {
                    "text": "There are some items in your bundle [{bundle_name}] that requires your attention",
                    "links": {
                        "ios": "/bundle/{bundle_id}",
                        "android": "/bundle/{bundle_id}",
                        "eshop": "/my-bundle/details/{bundle_id}"
                    }
                }
            }
        },
        "bonus": {
            "pc": {
                "title": "PC #{name}"
            },
            "iwb": {
                "1p_fourth_level_onward": "快速啟動獎金1%從第四層到無限層",
                "2p_second_level": "快速啟動獎金2%從第二層",
                "2p_third_level": "快速啟動獎金2%從第三層",
                "20p_first_level": "快速啟動獎金20%從第一層",
                "inactive_brand_ambassador": "不活躍品牌大使",
                "active_brand_ambassador": "活躍品牌大使"
            },
            "general": {
                "paid_as_rank": "支付位階",
                "active_status": "活躍狀態",
                "no_of_3_star_director_legs": "# 3星總監線",
                "no_of_diamond_legs": "# 鑽石線",
                "left_business_volume": "左銷售業績(BV)",
                "right_business_volume": "右銷售業績(BV)"
            },
            "commission_and_bonuses": {
                "retail_bonus": "零售獎金",
                "iwb": "快速啟動獎金",
                "tvc": "團隊獎金",
                "mb": "對等獎金",
                "other_bonuses": "其他獎金",
                "sub_total": "總計"
            },
            "chp_gbp": {
                "total_shares": "總股份"
            },
            "paid_as_ranks": {
                "DRT": "總監",
                "2SDRT": "2星總監",
                "3SDRT": "3星總監",
                "DM": "鑽石",
                "2SDM": "2星鑽石",
                "3SDM": "3星鑽石",
                "PSD": "總裁",
                "2PSD": "2星總裁",
                "3PSD": "3星總裁",
                "CRO": "皇冠",
                "2CRO": "2星皇冠",
                "3CRO": "3星皇冠"
            },
            "builder_ranks": {
                "builder": "企業家",
                "pro_builder": "專業企業家",
                "elite_builder": "精英企業家",
                "ba": "品牌大使"
            },
            "bonus_statement": {
                "header_title": "獎金報表",
                "statement_date": "報表日期",
                "member_code": "會員編號",
                "name": "會員姓名",
                "tax_number": "統一編號",
                "highest_rank": "最高位階",
                "effective_rank": "支付位階",
                "address": "地址",
                "header_bonuses": "獎金項目",
                "gross_bonus": "總獎金",
                "gross_bonus_ratio_description": "每年愛康全球公佈獎金固定匯率：2022匯率",
                "infinity_welcome_bonus": "快速啟動獎金",
                "retail_bonus": "零售獎金",
                "team_volume_commission": "團隊獎金",
                "matching_bonus": "對等獎金",
                "car_house_fund": "超級跑車 & 豪華房產獎勵",
                "incentive": "額外獎勵活動",
                "global_pool_bank": "全球年度分紅獎金",
                "total_gross_bonus": "總獎金",
                "less_wht": "減：WHT",
                "net_bonus_payable_before_bank_charges": "應付淨獎金",
                "withdrawal_bank_charges_disclaimer": "在獎金提取期間，本公司將收取 %s %s 匯款費用。請注意，中轉銀行也會收取一些費用，因此實際應付金額可能與結單金額或錢包金額不符。",
                "infinity_welcome_bonus_details": "快速啟動獎金明細",
                "number": "編號",
                "join_date": "加入日期",
                "type": "類型",
                "level": "推薦代數",
                "local_amount": "獎金 (%s$)",
                "nett": "獎金 (美金$)",
                "tvc_details": "團隊獎金明細",
                "batch": "獎金週",
                "carry_forward": "移轉分數",
                "this_week_bv": "本獎金週新增BV",
                "this_week_ops": "本週OPS",
                "calculation_bv": "計算獎金BV分數",
                "tvc_point": "團隊獎金(TVC)",
                "flush": "移轉保留BV分數",
                "carry_over": "移轉BV分數",
                "value_per_point": "積分比值",
                "matching_bonus_details": "對等獎金明細",
                "matching_bonus_percentage": "%",
                "matching_bonus_point": "對等獎金",
                "tb_point": "團隊獎金",
                "iwb_nett_usd": "總獎金 (美金)",
                "usd": "美金"
            }
        },
        "message": {
            "user": {
                "locations_access_forbidden": "用戶無權登入位置模塊。",
                "resource_not_belong": "此資源不屬於您.",
                "un_authorized": "此操作未經授權",
                "email_unique": "該電子郵件已被使用。",
                "not-member": "用戶並非會員.",
                "invalid-account": "用戶帳號不再有效"
            },
            "status": {
                "success": "created successfully",
                "failed": "operation failed",
                "inactive": "不活躍"
            },
            "login": {
                "failed": "The password is incorrect, please try again.",
                "wrong-email": "The credentials you provided does not exist in our records",
                "access-denied": "Access Denied"
            },
            "logout": {
                "failed": "Something went wrong, please try again.",
                "success": "Logout Successful"
            },
            "guest": {
                "failed": "The system dose not allow guest to access at the moment, please try again later"
            },
            "delete": {
                "success": "Record Deleted Successfully",
                "fail": "Delete Failed"
            },
            "db": {
                "duplicate_entry": " Integrity constraint violation duplicate entry"
            },
            "product": {
                "un-available": "This product is not available in your country",
                "un-available-in-country": "This sku ({name}, {sku}) is not available in your country",
                "promo-dates": "Product promo with effective date {effective_date} and expiry date {expire_date} is invalid date rang.",
                "import-success": "products imported successfully",
                "kitting-product-un-available": "This product ({name} , {sku} ) is not available in your country, so its not available for this kitting",
                "un-available-in-shop": "The product is not available in shop",
                "country-not-exists": "The given country ({code}) for this productId ({productID}) is not exists in IBS System, please contact the admin",
                "either-should-exist": "The product or kitting should be set",
                "member-not-eligible": "A product has been removed from the list because the selected member is not eligible for it."
            },
            "empty": "sorry no data",
            "member": {
                "members-only-area": "only members can make request to this API",
                "not-sponsor-child": "User {userId} is not sponsor child of logged in user.",
                "verification-email-sent": "Email Sent",
                "verification-email-subject": "Email Verification Code",
                "email-verified": "Email has been verified.",
                "otp-code": "Email Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-validated": "OTP Validated.",
                "status": "This member is {title}",
                "member-not-ba": "This sponsor member is not BA"
            },
            "member-migrate": {
                "different-country": "New country and current country must be different."
            },
            "member-rank": {
                "different-enrollment-rank": "New enrollment rank and current enrollment rank must be different.",
                "different-highest-rank": "New highest rank and current highest rank must be different."
            },
            "member-status": {
                "different-status": "new status and current status must be different."
            },
            "member-placement-verify": {
                "is-not-valid-upline": "The placement user does not belong to the sponsor user id",
                "occupied": "The placement has been occupied",
                "valid": "The placement is available"
            },
            "member-placement-outer": {
                "no-outer-left": "最外左下綫懸空。",
                "no-outer-right": "最外右下綫懸空。"
            },
            "workflow": {
                "completed": "{name} for {documentId} is already completed."
            },
            "cw": {
                "current_or_previous_cw": "You need to choose current CW or previous CW - 1 back date",
                "cw": "PC",
                "active_for": "2PC"
            },
            "sales-cancellation": {
                "invalid-member-invoice": "This member and invoice is not match.",
                "invoice-in-sale-cancellation-process": "This invoice was under sales cancellations process.",
                "max-product-quantity": "{productName} quantity may not be greater than {max}.",
                "un-available-product-cancel": "This invoice has been fully cancelled or exchanged.",
                "un-available-sale-cancellation-refund": "This cancellation batchs unavailable be refund."
            },
            "sales": {
                "sales-is-not-in-pre-order-status": "This sale has not in pre-order status.",
                "not-completed": "This sale is not completed, its in {status} status",
                "minimum-amp-cv": "Minimum {minimumCv} AMP CV required.",
                "minimum-enrollment-upgrade-cv": "Minimum {minimumCv} Upgrade CV required.",
                "not-able-to-back-date": "This sale not able to back date.",
                "rental-sale-not-able-to-release": "This rental sale not able to release.",
                "rental-sale-not-able-to-update-pre-screen-status": "This rental sale not able to update pre screen status.",
                "rental-sale-not-able-to-update-credibility-status": "This rental sale not able to update credibility status.",
                "rental-sale-not-able-to-update-ek-smart-number": "This rental sale not able to update EK Smart number.",
                "already-paid": "This sale is already paid."
            },
            "sales_exchange": {
                "qty_exceed": "The return quantity of product ({name} , {sku} ) exceeded the available quantity"
            },
            "currency-conversion": {
                "invalid-cw-id": "The given cw is duplicate entry with same currencies convert."
            },
            "stockist-log-message": {
                "initial": "Initial"
            },
            "stockist-payment-validation-message": {
                "zero-adjustment-amount": "Total of adjustment amount must be zero."
            },
            "consignment-transaction-message": {
                "consignment-deposit-amount-range": "Consignment deposit amount must within the deposit range.",
                "consignment-refund-capping-amount": "Capping amount is less than minimum capping amount.",
                "consignment-order-deposit-limit-amount": "Order amount is bigger than deposit limit amount.",
                "consignment-return-under-pending-status": "This stockist had a consignment return under pending status.",
                "un-available-quantity-return-product": "Return quantity of this product ({name} , {sku} ) can not more than {quantity}.",
                "block-consignment-return": "Another consignment transaction is in process.",
                "invalid-update-id": "This consignment transaction cannot be update."
            },
            "aeon-payment-update-agent-code": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "invalid-agent-code": "Agent code of this aeon payment has been updated."
            },
            "aeon-payment-cooling-off-release": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "aeon-payment-released": "This aeon payment has been released.",
                "invalid-aeon-payment-status": "This aeon payment is not yet been approved.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "epp-moto-payment-update-approve-code": {
                "invalid-epp-moto-payment-id": "Approval code has been submitted.",
                "invalid-epp-moto-payment-status": "This epp payment has been approved.",
                "epp-moto-payment-not-approved": "This epp payment not yet approve.",
                "epp-moto-payment-converted": "This epp payment has been converted.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "aeon-payment-update-agreement-number": {
                "invalid-aeon-payment-id": "Agreement number has been submitted.",
                "invalid-aeon-payment-status": "This aeon payment has been approved.",
                "invalid-approved-amount": "Approved amount is bigger than payment amount.",
                "invalid-sale-order-status": "This sale is cancelled.",
                "empty-agent-code": "Missing egent code in this payment."
            },
            "make-payment": {
                "skip-downline-make-full-payment": "Cannot make full sale payment for same sponsor and downline user.",
                "amount-excess": "Pay amount was excess total amount.",
                "single-payment-trasnaction": "This transaction only allow make one payment.",
                "required-input-field": "The {name} field is required.",
                "ewallet-invalid-ibo-id": "Invalid IBO ID",
                "ewallet-invalid-pin-no": "Invalid Pin No.",
                "ewallet-insufficient-balance": "Insufficient balance to make payment, current balance : {balance}.",
                "invalid-payment-record": "Invalid Payment Record.",
                "invalid-card-number": "Invalid Card Number",
                "epp-eligibility-invalid-tenure": "Invalid epp payment tenure.",
                "epp-eligibility-insufficient-loan-amount": "Invalid requested epp amount. Min requested amount : {amount}.",
                "invalid-payment-mode": "Invalid payment mode."
            },
            "country": {
                "already-set": "Country is already set",
                "not-set": "Country is not set",
                "not-exists-relation": "This {name} relation/filter is not exists in Country/Filters Model/Table"
            },
            "location": {
                "already-set": "Location is already set"
            },
            "query-building": {
                "unknown-union-type": "The union type defined is not known",
                "active-status-cannot-change": "Cannot change status now",
                "invalid-ordering-type": "Invalid ordering type"
            },
            "e-wallet": {
                "not-activated": "e-Wallet is not been activated yet",
                "inactive": "e-Wallet is inactive",
                "blocked": "e-Wallet is blocked",
                "backoffice-ewallet-error": "BackOffice EWallet Account does not have sufficient funds",
                "withdraw-amount-check": "Amount cannot be less than USD 10",
                "adjustment-amount-check": "Failed: Insufficient Funds",
                "otp-code": "Elken Mobile Verification Code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "otp-code-valid": "The code is valid",
                "number_validated": "Mobile Number Validated.",
                "rejected_payment_submit_error": "Submitted file have error(s). Please fix them and upload again.",
                "rejected_payment_file_no_error": "Submitted file is incorrect. Please download sample file to get correct file template.",
                "transaction_description": {
                    "withdraw": "WITHDRAWAL TO BANK AC",
                    "withdrawal-charges": "WITHDRAWAL CHARGES",
                    "transfer-to": "TRF TO {details}",
                    "received-from": "RCV FROM {details}",
                    "adjustment": "BONUS ADJUSTMENT - {details}",
                    "giro-rejected": "WITHDRAWAL TO BANK AC REJECTED - {details}",
                    "welcome-bonus": "DAILY WELCOME BONUS",
                    "welcome-bonus-to": "DAILY WELCOME BONUS TO {details}",
                    "commission": "BONUS - {details}",
                    "commission-to": "BONUS TO {details}"
                },
                "recipient_reference": {
                    "withdraw": "Auto Withdrawal",
                    "withdrawal-charges": "Withdrawal Charges"
                }
            },
            "giro": {
                "run": "Initialized Run for GIRO - {details}. The data will be ready for viewing in a while.",
                "export": "Initialized Export for GIRO - {details}. The file will be ready for download in a while.",
                "generate": "Initialized Generate for GIRO - {details}. The file will be ready for download in a while."
            },
            "console-task-scheduling": {
                "current-cw-update": "Current cw update successfully.",
                "aeon-respond-receive": "Aeon payment status update successfully.",
                "aeon-send-request": "Send aeon payment request file successfully.",
                "stockist-daily-sales-payment": "Stockist daily sales payment update successfully.",
                "stockist-commission-daily-update": "Stockist commission daily update successfully.",
                "payment-transaction-query": "Payment transaction query run successfully.",
                "update-member-expiry-status": "Member expiry status update successfully."
            },
            "dummy": {
                "un-available-dummy-product-setup": "This product ({name} , {sku} ) was exist in other dummy."
            },
            "campaign": {
                "invalid-to": "{to} value must either be zero OR not less than {from} value.",
                "exclude-product": "Selected product is not valid for the redemption. (exclusion list)",
                "include-product": "Selected product is not valid for the redemption. (not included)",
                "exclude-kitting": "Selected kitting is not valid for the redemption. (exclusion list)",
                "include-kitting": "Selected kitting is not valid for the redemption. (not included)",
                "max-purchase-qty": "Total sale purchase quantity cannot more than total voucher max purchase quantity.",
                "min-purchase-amount": "Total sale purchase amount cannot less than total voucher min purchase amount.",
                "cannot-delete-used-master": "Deleting not allowed because the {master} ({name}) is currently in use.",
                "cannot-edit-used-master": "Editing not allowed because the {master} is currently in use"
            },
            "foreign": {
                "not_belong": "This given foreign key ({foreign}) is not belongs to a given ({primary}) primary key"
            },
            "mobile": {
                "code": "Elken Enrollment Mobile Verification code : {code}",
                "unique_id": "您的愛康註冊專屬ID : {unique_id}，請保留此ID以便恢復註冊備用",
                "verified": "This mobile {number} is verified",
                "max_send_count": "You reached the max tries of verifying phone, you can try after 24 hours",
                "sms_failed": "Something went wrong, we can not send sms to your phone. please contact support",
                "sms_sent": "Message Sent",
                "wrong_code": "The code you sent is invalid",
                "exists": "This mobile already used. please contact support.",
                "not_exists": "This mobile number does not exist.",
                "already_sent": "The sms has already been sent. Please wait 5 minutes before you retry."
            },
            "email": {
                "code": "Elken Enrollment Email Verification code : {code}",
                "unique_id": "Elken Enrollment Unique id : {unique_id}, please keep this unique id to continue enrollment later.",
                "verified": "This email {email} is verified",
                "max_send_count": "You reached the max tries of verifying email, you can try after 24 hours",
                "email_failed": "Something went wrong, we can not send email to your email address. please contact support",
                "wrong_code": "The code you sent is invalid",
                "already_sent": "The email has already been sent. Please wait 5 minutes before you retry."
            },
            "stockist_commission_not_found": "The stockist {user} does not have a stockist commission in commission week {cw}",
            "cart": {
                "empty": "您的購物車是空的",
                "checkout": "進行結賬",
                "cannot-checkout": "無法結帳",
                "cannot-checkout-epp": "無法將EPP產品和正式產品合併結賬",
                "cannot-checkout-epp-backoffice": "無法添加{sku}。 EPP產品和正式產品不能結合使用。",
                "delivery-stock-location-not-found": "我們無法送達指定地址",
                "virel-referrer-empty": "您的環節沒有推薦人"
            },
            "cv": {
                "cannot-filter-sales-type-after-cv": "Cannot filter sales types after cv filtration",
                "minimum_cv_requirement": "請確保您在購買前已達 {cv} {eligibleType} 的最低AMP額度",
                "minimum_cv_to_active": "添加 {cv} BV 以激活 {cw}",
                "to_next_rank": "{cv} RNK required to achieve the next rank type",
                "calculation": "{cv} {eligibleType}",
                "eligible": "Eligible",
                "upgrade": "RNK",
                "append": "Amp",
                "wp": "WP",
                "base": "Base",
                "amp": "AMP",
                "stockist_base": "Stockist Base",
                "stockist_wp": "Stockist WP",
                "enrol_cv": "Enrol CV"
            },
            "payment-cancellation": {
                "payment-completed": "This payment is completed.",
                "payment-cancelled": "This payment is cancelled.",
                "aeon-payment-approved": "This aeon payment is approved.",
                "invalid-aeon-payment": "This is not a aeon payment record.",
                "epp-moto-payment-approved": "This epp moto payment is approved.",
                "invalid-epp-moto-payment": "This is not a epp moto payment record.",
                "invalid-sale-order-status": "This sale is cancelled."
            },
            "enrollment": {
                "sponsor_required": "You need to choose your sponsor member",
                "id_passport_not_unique": "The passport/ic number is not unique",
                "cant_resume": "This Enrollment already {status}",
                "member_enrollment_product_un_available": "This ({product}) - sku ({sku}) is not available for Member Enrollment Type ",
                "spouse_exists": "Spouse ID or Passport do not exist in Elken Global membership.",
                "spouse_unique": "Spouse ID or Passport already exist."
            },
            "master": {
                "invalid-sale-type": "The sale type is invalid",
                "master-not-found": "Master not found"
            },
            "evoucher": {
                "sent": "Sent Successfully",
                "sms": "EVoucher Activation code is {otp}. This code will be expired in {validity_time_in_minute} minutes.",
                "email": "\n            Dear {name},\n            <br><br>\n\n            We have received notification that you want to activate your EVoucher.\n            <br>\n            Please enter the EVoucher Activation code : {otp}\n            <br>\n            The code will only be valid for {validity_time_in_minute} minutes.\n            <br><br>\n            To Your Success!\n            <br>\n            The Management Team\n            <br><br>\n            Web : www.elkenglobal.com\n            Email : customerservice@elken.com\n            <br><hr>\n            <br><br>\n            <div style=\"text-align: center;\">< - - - This message was generated automatically. Please do not reply. - - - ></div>\n        "
            },
            "zone": {
                "postcode-duplicated": "The zone postcode {postcode} is duplicated",
                "stock-location-duplicated": "The zone stock location ({effectiveDate}, {expiryDate}) is duplicated"
            },
            "tax": {
                "tax-zone-duplicated": "The tax zone ({zoneId}, {effectiveDate}, {expiryDate}) is duplicated"
            },
            "delivery-charge": {
                "delivery-charge-zone-duplicated": "The delivery charge zone ({zoneId}, {effectiveDate}, {expiryDate}, {fromPaymentAmount}, {toPaymentAmount}) is duplicated"
            },
            "generate-report": {
                "empty": "Sorry, there is no data for this report.",
                "fail": "Error in generating the report, please try again.",
                "generating": "Your report is now being generated, it will be available shortly.",
                "email": {
                    "subject": "Generated report",
                    "template": "\n                Dear {name}, <br><br>\n\n                The report that you requested have been generated.<br>\n                Kindly use the link(s) below to get the generated reports.<br><br>\n            ",
                    "return-message": "As the report you are requesting contains a lot of data, it will be sent to your email once it is ready. You may close this window."
                }
            },
            "token": {
                "could-not-extend-token": "Could not extend the token"
            },
            "bonus": {
                "bonus-tree-memory-exceeded": "Bonus tree memory has exceeded",
                "adjustment_file_submit_error": "Submitted file have error(s). Please fix them and upload again."
            },
            "report-publish-config": {
                "unique": "The given config already exists."
            },
            "report-year": {
                "unique": "The given report publish time for year {year} already exists."
            },
            "qr": {
                "payment": {
                    "process": "Please Wait. We are processing your payment",
                    "redirect": "If you are not redirected in 5 seconds, click the button below"
                }
            },
            "payment": {
                "process": "請稍候。我們正在處理您的款項",
                "process-processed": "您的付款{status}",
                "already-processed": "此付款已處理",
                "status-success": "已成功",
                "status-pending": "等待中",
                "status-failed": "失敗了",
                "success": "成功",
                "pending": "待辦",
                "failed": {
                    "header_title": "付款失敗",
                    "webview_body_text": "您的訂單付款失敗。您可以點擊以下按鈕返回銷售訂單。",
                    "non_webview_body_text": "您的訂單付款失敗",
                    "return_button_title": "返回"
                },
                "msg-success": "謝謝",
                "msg-pending": "您的付款尚待處理，完成後我們會通知您",
                "msg-failed": "請再試一次",
                "status-successful": "已成功",
                "redirect": "如果5秒鐘內您沒有被重新定向，請點擊下面的按鈕",
                "continue": "繼續",
                "empty": "發生問題！ ！ ！請聯絡支援團隊以進行諮詢",
                "sale-completed": "這筆訂單已付清。",
                "sale-disabled": "Payment is not available for this sale [{status}]",
                "completed": {
                    "header_title": "付款成功",
                    "webview_body_text": "謝謝您的付款。接下來，您可以點擊以下按鈕以完成訂購。",
                    "webview_complete_payment_button_title": "完成付款",
                    "non_webview_body_text": "謝謝您的付款。接下來，您可以聯絡發送付款鏈接給您的人以確認訂單狀態。",
                    "non_webview_share_button_title": "分享",
                    "non_webview_with_callback_body_text": "謝謝您的付款。接下來，您可以點擊以下按鈕返回到訂單狀態頁面。",
                    "non_webview_with_callback_button_title": "返回",
                    "sharer_title": "愛康環球",
                    "sharer_description": "我已經成功使用{payment_provider_name}付款{currency_iso_code}{total_payment_amount}於訂單{sale_document_number}。"
                }
            },
            "membership": {
                "unique_role": "The membership role already exists with same settings",
                "condition_eligibility": "The condition you choose is not eligible for the enrollment type"
            },
            "employment": {
                "label": "Employment Details",
                "button": "Fill Up Here",
                "link": "Click on the following button to fill up your employment details before proceed to the next step."
            },
            "autoship": {
                "queue_success": "Your Autoship subscription is queued to be created after enrolment process  completed."
            },
            "trueyou_activation": {
                "email": {
                    "subject": "TrueYou Activation Code",
                    "dear": "Dear TrueYou customer,",
                    "body": "Please use the following activation code to activate you saliva collection kit online."
                },
                "sms": "Your TrueYou activation code is {code}."
            },
            "document": {
                "warning_note": "Unauthorised selling of Elken products on e-commerce platforms and social media websites (e.g. Lazada, Shopee, Carousell and others) is strictly not allowed."
            }
        },
        "team_volume_commission": {
            "codes": {
                "tvc10": "TVC10",
                "tvc15": "TVC15",
                "tvc20": "TVC20"
            },
            "names": {
                "tvc10": "TVC 10%",
                "tvc15": "TVC 15%",
                "tvc20": "TVC 20%"
            },
            "criteria": {
                "first": "12 Pay Cycles is comprised of your enrollment Pay Cycle plus the next 11 Pay Cycle.",
                "second": "You may only upgrade ONCE after your initial enrollment Kit purchase.",
                "third": "Upgrade Kits do no count towards monthly Active qualification."
            }
        }
    }
}
